const mixins = {
  kioskHeader: {
    height: 110,
  },
  kioskFooter: {
    height: 576,
  },
  homeLayout: {
    height: 576,
  },
  kioskVNavigation: {
    height: 232,
    width: 904,
  },
  kioskVSearchBar: {
    height: 80,
  },
  pageLayout: {
    height: 1344,
  },
}

// TODO: Remove this line after refactoring the toolbar into a single component
const NAV_PAGE_STYLE_OVERRIDES = {
  navigationWrapper: {
    marginBottom: `${mixins.kioskVNavigation.height}px`,
    bottom: 0,
    padding: "0 64px",
  },
  toolbarContainer: {
    gap: "16px",
    marginLeft: "auto",
    alignItems: "center",
    flexDirection: "row",
  },
  searchBarContainer: {
    height: `${mixins.kioskVSearchBar.height}px`,
    order: -1,
    width: "max-content",
  },
}

export const themeOptionFactory = (theme) => ({
  mixins,
  assets: {
    logo: {
      url: "https://s3.venue.in.th/iconsiam_header_logo_7e17a33f76.png",
    },
    loadingScreen: {
      url: "https://s3.venue.in.th/Logo_78f1db8fcb.png",
    },
  },
  components: {
    MuiSwitch: {
      styleOverrides: {
        root: {
          width: "48px",
          height: "28px",
          padding: 0,
          margin: theme.spacing(1),
          display: "flex",
          alignItems: "center",
          "& .MuiSwitch-thumb": {
            width: "22px",
            height: "22px",
          },
          "&:active": {
            "& .MuiSwitch-thumb": {
              width: "22px",
            },
            "& .MuiSwitch-switchBase.Mui-checked": {
              transform: "translateX(9px)",
            },
          },
          "& .MuiSwitch-switchBase": {
            padding: theme.spacing(0.375),
            "&.Mui-checked": {
              transform: "translateX(20px)",
              "& + .MuiSwitch-track": {
                opacity: 1,
                backgroundColor: theme.palette.primary.main,
              },
            },
          },
        },
        switchBase: {
          margin: theme.spacing(1),
          marginTop: theme.spacing(0.05),
          "&.Mui-checked": {
            transform: "translateX(7px)",
          },
        },
        track: {
          width: "48px",
          height: "28px",
          borderRadius: "9999px",
        },
      },
    },
    MuiToggleButtonGroup: {
      variants: [
        {
          props: { variant: "borderSeperate" },
          style: {
            "& .MuiToggleButtonGroup-grouped:not(:first-of-type)": {
              border: "1px solid #E2E2E4",
            },
          },
        },
      ],
    },
    LoadingScreen: {
      styleOverrides: {
        logo: {
          width: "500px",
        },
        loadingRoot: {
          position: "relative",
        },
        loadingTrack: {
          color: theme.palette.grey[200],
        },
        loadingIndicator: {
          color: "#E3D7AA",
          animationDuration: "3000ms",
          position: "absolute",
          left: 0,
          [`& .MuiCircularProgress-circle`]: {
            strokeLinecap: "round",
          },
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        ".maptalks-canvas-layer": {
          backgroundColor: theme.palette.common.white,
        },
        "@keyframes horizontal-bounce": {
          "0%": {
            opacity: 0.75,
            transform: "translateX(0)",
          },
          "50%": {
            opacity: 1,
            transform: "translateX(-6px)",
          },
          "100%": {
            opacity: 0.75,
            transform: "translateX(0)",
          },
        },
        html: {
          body: {
            backgroundColor: "transparent !important",
          },
          "&.home-screen": {
            "& .AppLayout-root": {
              height: `${mixins.homeLayout.height}px !important`,
              position: "fixed",
              bottom: 0,
              left: 0,
              right: 0,
            },
            "& .MuiBackdrop-root": {
              height: `${mixins.homeLayout.height}px !important`,
              marginTop: "auto",
              bottom: 0,
            },
            "& .loading-screen": {
              height: `${mixins.homeLayout.height}px !important`,
              bottom: 0,
              left: 0,
              right: 0,
            },
          },
        },
        ".MuiBackdrop-root, .MuiModal-root": {
          top: "auto !important",
          height: `${mixins.pageLayout.height}px !important`,
          bottom: 0,
        },
        ".MuiPopover-paper": {
          marginTop: `-${mixins.homeLayout.height}px !important`,
        },
        ".loading-screen": {
          height: `${mixins.pageLayout.height}px !important`,
          bottom: 0,
          left: 0,
          right: 0,
        },
        ".AppLayout-root": {
          position: "absolute",
          height: `${mixins.pageLayout.height}px !important`,
          backgroundColor: theme.palette.background.default,
          overflow: "hidden",
          left: 0,
          right: 0,
          bottom: 0,
        },
        ".is-rtl": {
          "& .MuiSvgIcon-root": {
            transform: "rotate(180deg) !important",
          },
        },
      },
    },
    MuiBackdrop: {
      styleOverrides: {
        root: {
          top: "auto",
          bottom: 0,
        },
      },
    },
    MuiModal: {
      styleOverrides: {
        root: {
          top: "auto",
          bottom: 0,
        },
      },
    },
    AppLayout: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "column",
        },
        headerWrapper: {
          display: "block",
          height: mixins.kioskHeader.height,
        },
        footerWrapper: {
          display: "none",
        },
        contentWrapper: {},
      },
    },
    AppHeader: {
      styleOverrides: {
        root: {
          position: "relative",
          backgroundColor: "transparent",
          zIndex: theme.zIndex.appBar,
          "&::after": {
            content: "''",
            position: "absolute",
            top: 0,
            zIndex: -1,
            background:
              "url(https://s3.venue.in.th/header_test_923196d3d2.png) top center no-repeat",
            backgroundSize: "100%",
            width: "100%",
            height: "180px",
          },
        },
        toolbar: {
          display: "flex",
          justifyContent: "center",
        },
        titleContainer: {
          display: "none",
        },
        clockContainer: {
          display: "none",
        },
        logoImage: {
          width: "288px",
          paddingTop: theme.spacing(5.25),
          marginLeft: theme.spacing(-2),
        },
      },
    },
    BaseModal: {
      styleOverrides: {
        root: {},
        container: {
          height: "100%",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        },
        closeIconButton: {
          marginTop: theme.spacing(2.5),
          background: "#F8F8FF",
          border: `1px solid ${theme.palette.divider}`,
          width: "82px",
          height: "82px",
          borderRadius: "50%",
          ":hover": {
            background: "#F8F8FF",
          },
        },
        closeIcon: {
          width: "20px",
          height: "20px",
        },
      },
    },
    IframeModal: {
      defaultProps: {
        iframeOptions: {},
      },
      styleOverrides: {
        root: {
          "& .BaseModal-closeButton": {
            marginTop: theme.spacing(-2.5),
          },
          "&.IframeModal-transportation-iframe iframe": {
            width: "100vw",
            height: "1053px",
            transform: "scale(0.95)",
          },
        },
        contentContainer: {},
        iframe: {
          // !Fix: Prevent non-responsive sites from overflowing the horizontal edges of the iframe.
          width: "100%",
          height: "100%",
          backgroundColor: theme.palette.background.paper,
          borderRadius: "20px",
        },
      },
    },
    DiningCard: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "column",
          minHeight: "345px",
          height: "345px",
          width: "223px",
          maxWidth: "223px",
          borderRadius: "8px",
          position: "relative",
          background:
            "linear-gradient(180deg, #FFFFFF 71%, #EDEEEE 100%, #FFF) padding-box, linear-gradient(333deg, #D6C380 30%, #EEE7CC 81.85%) border-box",
          border: "1px solid transparent",
          boxShadow: "none",
        },
        featuredImage: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          boxShadow: "none",
          flexDirection: "column",
          position: "relative",
          "& .MuiAvatar-root": {
            borderRadius: "0",
            width: "223px",
            height: "216px",
          },
          "& .MuiAvatar-img": {
            objectFit: "cover",
          },
          "& .MuiSvgIcon-root": {
            width: 64,
            height: 64,
          },
        },
        cardContent: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          padding: theme.spacing(5, 1, 0),
          height: "129px",
        },
        levelAvatar: {
          width: 32,
          height: 32,
          fontSize: "0.875rem",
          fontWeight: 700,
          color: theme.palette.common.white,
          background:
            "url(https://s3.venue.in.th/level_Icon_b460ba199f.svg) , no-repeat",
          marginRight: theme.spacing(-0.5),
        },
        venueLogo: {
          objectFit: "contain",
          maxHeight: "44px",
          width: "90px",
        },
        titleText: {
          color: theme.palette.text.primary,
          fontSize: "1.125rem",
          lineHeight: 1.4,
          fontWeight: 700,
          textOverflow: "ellipsis",
          overflow: "hidden",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          maxHeight: "54px",
        },
        detailWrapper: {
          display: "flex",
          gap: theme.spacing(0.75),
          flexDirection: "column",
        },
        infoContainer: {
          minHeight: "44px",
          height: "44px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          marginTop: 0,
          alignItems: "center",
        },
        logo: {
          width: 68,
          height: 68,
          marginTop: theme.spacing(-9.75),
          borderRadius: "8px",
          border: `2px solid ${theme.palette.common.white}`,
          backgroundColor: theme.palette.background.paper,
          color: theme.palette.text.secondary,
          "& .MuiAvatar-img": {
            borderRadius: "6px",
          },
        },
        chipContainer: {
          padding: theme.spacing(0.75),
          left: 0,
          right: 0,
          top: 0,
          position: "absolute",
          zIndex: 1,
        },
        chip: {
          width: 32,
          height: 32,
          borderRadius: "100px",
          background:
            "linear-gradient(293deg, #C8AF55 24.06%,  #EEE7CC 90.57%)",
          "& .MuiChip-label": {
            padding: 0,
            display: "flex",
            alignItems: "center",
          },
          "& .MuiSvgIcon-root": {
            width: 20,
            height: 20,
            fill: theme.palette.primary.main,
          },
        },
        adsChip: {
          marginLeft: "auto",
          padding: theme.spacing(1),
          height: "20px",
          borderRadius: "24px",
          backgroundColor: "rgba(73, 70, 86, 0.6)",
          "& .MuiChip-label": {
            padding: 0,
            fontSize: "0.75rem",
            fontWeight: 400,
            color: "#E2E2E4",
          },
        },
        newShopChip: {},
        comingSoonChip: {},
        vatRefundChip: {
          display: "flex",
          position: "absolute",
          bottom: "8px",
          left: "80px",
          zIndex: 1,
        },
        multiLevelContainer: {
          display: "flex",
          marginRight: theme.spacing(-0.5),
          "& > *:first-of-type": {
            borderRadius: "16px 0 0 16px",
            width: 36,
            paddingLeft: theme.spacing(0.5),
            borderRight: `0.4px solid ${theme.palette.divider}`,
          },
          "& > *:last-of-type": {
            borderRadius: "0 16px 16px 0",
            width: 36,
            paddingRight: theme.spacing(0.5),
          },
          "& > *:not(:first-of-type):not(:last-of-type)": {
            borderRadius: 0,
            borderRight: `0.4px solid ${theme.palette.divider}`,
          },
        },
        multiLevelAvatar: {
          width: 32,
          height: 32,
          fontSize: "0.875rem",
          fontWeight: 700,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: theme.palette.primary.contrastText,
          backgroundColor: theme.palette.primary.main,
        },
      },
    },
    DirectoryOccupantCard: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "column",
          width: "222px",
          height: "374px",
          borderRadius: "8px",
          position: "relative",
          boxShadow: "none",
          border: "1px solid transparent",
          background:
            "linear-gradient(180deg, #FFFFFF 71%, #EDEEEE 100%, #FFF) padding-box, linear-gradient(333deg, #D6C380 30%, #EEE7CC 81.85%) border-box",
        },
        occupantLogo: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          boxShadow: "none",
          "& .MuiAvatar-root": {
            borderRadius: "0",
            width: "100%",
            height: "220px",
            "& .MuiSvgIcon-root": {
              width: "56px",
              height: "56px",
            },
          },
          "& .MuiAvatar-img": {
            objectFit: "cover",
          },
        },
        cardContent: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          padding: theme.spacing(1.5),
          paddingBottom: theme.spacing(0),
          height: "100%",
          width: "100%",
          "& .MuiTypography-root": {
            lineHeight: 1.4,
          },
        },
        levelAvatar: {
          width: 32,
          height: 32,
          fontSize: "0.875rem",
          fontWeight: 700,
          marginRight: theme.spacing(-0.5),
          color: theme.palette.primary.contrastText,
          background:
            "url(https://s3.venue.in.th/level_Icon_b460ba199f.svg) , no-repeat",
        },
        divider: {
          display: "flex",
          borderBottomWidth: "1px",
          borderImage:
            "linear-gradient(291deg, #EEE7CC 0%, #AC8700 50%, #EEE7CC 100%) 1",
        },
        venueLogo: {
          objectFit: "contain",
          height: "100%",
          width: "90px",
        },
        titleText: {
          fontSize: "1rem",
          fontWeight: 700,
          flexGrow: 1,
          color: theme.palette.text.primary,
        },
        detailWrapper: {
          display: "flex",
          flexDirection: "column",
        },
        infoContainer: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          marginTop: 0,
          alignItems: "center",
          height: "44px",
        },
        categoryText: {
          fontSize: "0.75rem",
          fontWeight: 300,
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          WebkitLineClamp: 1,
          color: "#6A6A6A",
          marginBottom: theme.spacing(1),
        },
        chipContainer: {
          position: "absolute",
          display: "flex",
          top: 0,
          width: "100%",
          zIndex: 2,
          padding: theme.spacing(0.75),
        },
        adsChip: {
          marginRight: "auto",
          padding: theme.spacing(1),
          height: "20px",
          borderRadius: "24px",
          backgroundColor: "rgba(73, 70, 86, 0.6)",
          "& .MuiChip-label": {
            padding: 0,
            fontSize: "0.75rem",
            fontWeight: 400,
            color: "#E2E2E4",
          },
        },
        newShopChip: {},
        comingSoonChip: {},
        vatRefundChip: {
          display: "flex",
          width: "97px",
          height: "18px",
          marginBottom: theme.spacing(0.5),
          "& .MuiChip-label": {
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontSize: "0.625rem",
          },
        },
        multiLevelContainer: {
          display: "flex",
          marginRight: theme.spacing(-0.5),
          "& > *:first-of-type": {
            borderRadius: "16px 0 0 16px",
            width: 36,
            paddingLeft: theme.spacing(0.5),
            borderRight: `0.4px solid ${theme.palette.divider}`,
          },
          "& > *:last-of-type": {
            borderRadius: "0 16px 16px 0",
            width: 36,
            paddingRight: theme.spacing(0.5),
          },
          "& > *:not(:first-of-type):not(:last-of-type)": {
            borderRadius: 0,
            borderRight: `0.4px solid ${theme.palette.divider}`,
          },
        },
        multiLevelAvatar: {
          width: 32,
          height: 32,
          fontSize: "0.875rem",
          fontWeight: 700,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: theme.palette.primary.contrastText,
          backgroundColor: theme.palette.primary.main,
        },
      },
    },
    DirectorySkeletonCard: {
      styleOverrides: {
        root: {
          flexDirection: "column",
          borderRadius: "8px",
          boxShadow: "none",
          width: "222px",
          height: "374px",
          border: "1px solid transparent",
          background:
            "linear-gradient(180deg, #FFFFFF 71%, #EDEEEE 100%, #FFF) padding-box, linear-gradient(333deg,rgb(203, 195, 165) 30%, #EEE7CC 81.85%) border-box",
        },
        avatar: {
          boxShadow: "none",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flex: "0 0 222px",
          width: "100%",
          height: "100%",
        },
        logo: {
          boxShadow: "none",
          order: 9999,
          height: "40px",
          margin: theme.spacing(1.5),
          marginTop: "auto",
        },
        cardContent: {
          padding: theme.spacing(1.5),
        },
      },
    },
    VuiSearchResult: {
      styleOverrides: {
        listItem: {
          width: "222px",
          height: "298px",
        },
      },
    },
    VenueSelector: {
      styleOverrides: {
        root: {
          display: "flex",
          justifyContent: "space-between",
          height: "64px",
          width: "304px",
          background: "#ECECED",
          border: `2px solid ${theme.palette.background.paper}`,
          borderRadius: "64px",
          padding: theme.spacing(0.5),
          gap: 0,
          boxShadow:
            "0px 45px 13px 0px rgba(0, 0, 0, 0.00), 0px 29px 11px 0px rgba(0, 0, 0, 0.01), 0px 16px 10px 0px rgba(0, 0, 0, 0.05), 0px 7px 7px 0px rgba(0, 0, 0, 0.09), 0px 2px 4px 0px rgba(0, 0, 0, 0.10)",
        },
        buttonWrapper: {
          height: "100%",
          transition: "none",
          "&.selected": {
            transform: "none",
            margin: 0,
          },
          "&.all": {
            order: 1,
          },
          "&.iconsiam": {
            order: 2,
          },
          "&.ics": {
            order: 3,
          },
        },
        button: {
          height: "auto",
          width: 98,
          display: "flex",
          justifyContent: "center",
          padding: theme.spacing(1, 1.5),
          borderRadius: "64px",
          backgroundColor: "transparent",
          "&.Mui-selected": {
            border: "1px solid #EDEEEE",
            background: "linear-gradient(180deg, #FFFFFF 38.03%, #EDEEEE 100%)",
            "&:hover": {
              background:
                "linear-gradient(180deg, #FFFFFF 38.03%, #EDEEEE 100%)",
              border: "1px solid #EDEEEE",
            },
          },
          "& .MuiAvatar-root": {
            borderRadius: 0,
          },
        },
        allVenueIcon: {
          display: "none",
        },
        icon: {
          height: "32px",
          width: "72px",
          "& img": {
            objectFit: "contain",
          },
        },
        allVenueLabel: {
          display: "flex",
          color: theme.palette.primary.main,
          fontSize: "1.25rem",
          fontWeight: 300,
          ".Mui-selected &": {
            fontWeight: 500,
          },
        },
        currentVenueChip: {
          display: "none",
        },
      },
    },
    AppMap: {
      styleOverrides: {
        ...NAV_PAGE_STYLE_OVERRIDES,
        ordinalSelector: {
          display: "inline-flex",
          position: "absolute",
          bottom: `${
            mixins.kioskVNavigation.height +
            mixins.kioskVSearchBar.height +
            200 +
            80
          }px`,
          right: "50px",
          marginBottom: theme.spacing(3),
          zIndex: theme.zIndex.modal - 1,
        },
        locationButtonContainer: {
          display: "flex",
          position: "absolute",
          bottom: `${
            mixins.kioskVNavigation.height + mixins.kioskVSearchBar.height + 200
          }px`,
          right: "50px",
          flexDirection: "column",
          gap: "20px",
          marginBottom: theme.spacing(1.5),
        },
        attractionButtonContainer: {
          display: "flex",
          position: "absolute",
          bottom: `${
            mixins.kioskVNavigation.height + mixins.kioskVSearchBar.height
          }px`,
          right: "50px",
          flexDirection: "column",
          gap: "20px",
          marginBottom: theme.spacing(3),
        },
        quickLinkContainer: {
          position: "absolute",
          bottom: "6px",
          left: "0",
          maxWidth: "740px",
          padding: theme.spacing(0, 0, 0, 8),
          marginRight: "auto",
          "&:after": {
            display: "none",
          },
          "&:before": {
            display: "none",
          },
          "& .MuiTabs-scroller": {
            padding: theme.spacing(1.25, 0),
          },
        },
        attractionButton: {
          display: "flex",
          position: "absolute",
          bottom: `${
            mixins.kioskVNavigation.height + mixins.kioskVSearchBar.height
          }px`,
          right: "30px",
          flexDirection: "column",
          gap: "20px",
          marginBottom: theme.spacing(1),
        },
      },
    },
    PromotionCard: {
      styleOverrides: {
        root: {
          width: "358px",
          minHeight: "786px",
          borderRadius: "24px",
          background:
            "linear-gradient(180deg, #FFFFFF 71%, #EDEEEE 100%) padding-box, linear-gradient(333deg, #D6C380 30%, #EEE7CC 81.85%) border-box",
          border: "1px solid transparent",
          boxShadow: "none",
          padding: 0,
          display: "flex",
          flexDirection: "column",
        },
        cardMedia: {
          width: "358px",
          height: "636px",
          maxHeight: "none",
          borderRadius: "none",
          objectFit: "cover",
          position: "relative",
        },
        duration: {
          color: "#948A8D",
          fontSize: "1rem",
          margin: 0,
        },
        cardTitle: {
          color: "#56464A",
          fontSize: "1.25rem",
          height: "56px",
          lineHeight: 1.3,
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          wordBreak: "break-word",
        },
        cardContent: {
          padding: theme.spacing(2),
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          "&:last-child": {
            paddingBottom: 0,
          },
        },
        cardInfoContainer: {
          height: "42px",
          position: "relative",
          marginTop: theme.spacing(1),
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          color: theme.palette.grey[700],
          fontSize: theme.typography.subTitle.fontSize,
          "& .MuiTypography-root": {
            fontSize: "1rem",
            color: "#948A8D",
          },
          "&::before": {
            content: "' '",
            position: "absolute",
            height: "1px",
            width: "100%",
            top: -4,
            background:
              "linear-gradient(290.55deg, #EEE7CC 0%, #AC8700 50%, #EEE7CC 100%)",
            visibility: "visible",
          },
        },
        venueLogoContainer: {
          display: "flex",
          position: "absolute",
          margin: theme.spacing(1.5, 2),
          bottom: 0,
          right: 0,
          "& .MuiCardMedia-root": {
            maxWidth: "90px",
            maxHeight: "43px",
          },
        },
        iconContainer: {
          width: "auto",
          marginRight: theme.spacing(1),
          "& .MuiSvgIcon-root": {
            height: "24px",
            color: theme.palette.primary.main,
          },
        },
        statusTextContainer: {
          width: "100%",
          backgroundColor: "#EFBB00",
          position: "absolute",
          padding: theme.spacing(0.75, 1.5),
          bottom: 0,
          left: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "52px",
        },
        statusText: {
          fontSize: "1.25rem",
          fontWeight: 700,
          color: theme.palette.primary.contrastText,
        },
        chipContainer: {
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          position: "absolute",
          padding: "5px 8px",
          zIndex: 1,
        },
        highlightTextChip: {
          height: "32px",
          display: "flex",
          padding: theme.spacing(0.5, 1.5),
          color: theme.palette.primary.contrastText,
          fontWeight: 700,
          marginRight: "auto",
          background: "linear-gradient(0deg, #AC8700 0%, #BA9B2A 88.96%)",
        },
        locationInfo: {
          maxWidth: "180px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 1,
          WebkitBoxOrient: "vertical",
        },
      },
    },
    PromotionPage: {
      defaultProps: {
        promotionCarouselOption: {
          gap: "32px",
          autoWidth: true,
        },
      },
      styleOverrides: {
        ...NAV_PAGE_STYLE_OVERRIDES,
        emptyDataContainer: {
          height: "826px",
        },
        carouselContainer: {
          gap: theme.spacing(2),
          "&:before": {
            content: "''",
            display: "inline-block",
            width: "113px",
            height: "934px",
            background: "linear-gradient(180deg, #F8F8FF, transparent);",
            maskImage:
              "linear-gradient(90deg, #000 0%, rgba(0, 0, 0, 0.00) 100%)",
            zIndex: 1,
            position: "absolute",
            top: 0,
            bottom: 0,
          },
          "&:after": {
            content: "''",
            display: "inline-block",
            width: "113px",
            height: "934px",
            background: "linear-gradient(90deg,transparent,#F8F8FF);",
            maskImage:
              "linear-gradient(180deg, #000 0%, rgba(0, 0, 0, 0.00) 100%)",
            zIndex: 1,
            position: "absolute",
            right: 0,
            top: 0,
            bottom: 0,
            left: "auto",
          },
          '[dir="rtl"] &': {
            "&:before": {
              background: "linear-gradient(270deg, #F8F8FF, transparent)",
              maskImage:
                "linear-gradient(270deg, #000 0%, rgba(0, 0, 0, 0.00) 100%)",
            },
            "&:after": {
              background: "linear-gradient(90deg, #F8F8FF, transparent)",
              maskImage:
                "linear-gradient(180deg, #000 0%, rgba(0, 0, 0, 0.00) 100%)",
            },
          },
        },
        carousel: {
          "& .splide": {
            margin: "0 auto",
            marginTop: theme.spacing(4.25),
          },
          "& .splide__pagination": {
            marginTop: theme.spacing(3),
          },
          "& .splide__pagination__page": {
            width: "16px",
            height: "16px",
          },
          "& .splide__pagination__page.is-active": {
            backgroundColor: theme.palette.primary.main,
            transition: `width ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut}, borderRadius ${theme.transitions.duration.standard}s ${theme.transitions.easing.easeInOut}`,
            transform: "none",
            width: "20px",
            height: "20px",
            borderRadius: "50%",
          },
          "& .splide__slide": {
            "&> *": {
              display: "inline-block",
              transform: "none",
              opacity: 0.6,
              transition: `all ${theme.transitions.duration.short}ms`,
            },
            "&.is-visible.is-active": {
              "&> *": {
                opacity: 1,
                transform: "none",
              },
            },
          },
        },
        venueSelector: {
          bottom: "8px",
          left: "50%",
          right: "unset",
          transform: "translateX(-50%)",
        },
      },
    },
    OccupantPromotionPage: {
      defaultProps: {
        promotionCarouselOption: {
          gap: "32px",
          autoWidth: true,
        },
      },
      styleOverrides: {
        ...NAV_PAGE_STYLE_OVERRIDES,
        carouselContainer: {
          "&:before": {
            content: "''",
            display: "inline-block",
            width: "113px",
            height: "934px",
            background: "linear-gradient(180deg, #F8F8FF, transparent);",
            maskImage:
              "linear-gradient(90deg, #000 0%, rgba(0, 0, 0, 0.00) 100%)",
            zIndex: 1,
            position: "absolute",
            top: 0,
            bottom: 0,
          },
          "&:after": {
            content: "''",
            display: "inline-block",
            width: "113px",
            height: "934px",
            background: "linear-gradient(90deg,transparent,#F8F8FF);",
            maskImage:
              "linear-gradient(180deg, #000 0%, rgba(0, 0, 0, 0.00) 100%)",
            zIndex: 1,
            position: "absolute",
            right: 0,
            top: 0,
            bottom: 0,
            left: "auto",
          },
          "[dir='rtl'] &": {
            "&:before": {
              background: "linear-gradient(90deg,transparent,#F8F8FF);",
              maskImage:
                "linear-gradient(180deg, #000 0%, rgba(0, 0, 0, 0.00) 100%)",
            },
            "&:after": {
              background: "linear-gradient(180deg, #F8F8FF, transparent);",
              maskImage:
                "linear-gradient(90deg, #000 0%, rgba(0, 0, 0, 0.00) 100%)",
            },
          },
        },
        carousel: {
          "& .splide": {
            margin: "0 auto",
            marginTop: theme.spacing(23.5),
          },
          "& .splide__pagination": {
            marginTop: theme.spacing(3.75),
          },
          "& .splide__pagination__page": {
            width: "16px",
            height: "16px",
          },
          "& .splide__pagination__page.is-active": {
            backgroundColor: theme.palette.primary.main,
            transition: `width ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut}, borderRadius ${theme.transitions.duration.standard}s ${theme.transitions.easing.easeInOut}`,
            transform: "none",
            width: "20px",
            height: "20px",
            borderRadius: "50%",
          },
          "& .splide__slide": {
            "&> *": {
              display: "inline-block",
              transform: "none",
              opacity: 0.6,
              transition: `all ${theme.transitions.duration.short}ms`,
            },
            "&.is-visible.is-active": {
              "&> *": {
                opacity: 1,
                transform: "none",
              },
            },
          },
        },
        promotionCard: {
          width: "262px",
          minHeight: "616px",
          "& .VerticalCard-cardMedia": {
            height: "466px",
            width: "100%",
          },
          "& .VerticalCard-venueLogo": {
            height: "24px",
          },
          "& .VerticalCard-chipContainer": {
            display: "flex",
            position: "absolute",
            top: "10px",
            left: "10px",
          },
          "& .VerticalCard-highlightChip": {
            height: "32px",
            display: "flex",
            padding: theme.spacing(0.5, 1.5),
            color: theme.palette.primary.contrastText,
            fontWeight: 700,
            marginRight: "auto",
            background: "linear-gradient(0deg, #AC8700 0%, #BA9B2A 88.96%)",
          },
        },
        actionButtonGroupContainer: {
          position: "absolute",
          left: "50%",
          transform: "translateX(-50%)",
          display: "flex",
          justifyContent: "center",
          width: "100%",
          gap: theme.spacing(3),
          paddingTop: 0,
          height: "80px",
        },
        button: {
          minWidth: 188,
          height: "80px",
        },
        emptyDataContainer: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          paddingTop: 0,
          paddingBottom: 0,
          height: "672px",
          position: "relative",
        },
      },
    },
    ShopPromotionHeader: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: theme.spacing(5),
        },
        headerContainer: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          paddingTop: theme.spacing(3),
          gap: theme.spacing(3),
        },
        labelContainer: {},
        labelText: {
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 1,
          WebkitBoxOrient: "vertical",
        },
        headerLogo: {
          display: "flex",
          flexDirection: "row",
          background: theme.palette.grey[400],
          color: theme.palette.primary.contentText,
          margin: 0,
          border: "none",
          width: 120,
          height: 120,
          borderRadius: "12px",
          "& .MuiSvgIcon-root": {
            width: 40,
            height: 40,
          },
        },
        headerTitle: {
          fontWeight: 700,
          color: "#494656",
          width: "460px",
          fontSize: "1.75rem",
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          lineHeight: 1.1,
        },
        divider: {
          height: "94px",
          borderBottomWidth: "1px",
          borderImage:
            "linear-gradient(291deg, #EEE7CC 0%, #AC8700 50%, #EEE7CC 100%) 1",
        },
      },
    },
    VerticalEventCard: {
      styleOverrides: {
        root: {
          minHeight: "786px",
          width: "358px",
          border: "1px solid transparent",
          borderRadius: "24px",
          display: "flex",
          flexDirection: "column",
          boxShadow: "none",
          background:
            "linear-gradient(180deg, #FFFFFF 71%, #EDEEEE 100%) padding-box, linear-gradient(333deg, #D6C380 30%, #EEE7CC 81.85%) border-box",
        },
        cardMedia: {
          width: "358px",
          height: "636px",
          objectFit: "cover",
          position: "relative",
        },
        duration: {
          color: "#948A8D",
          fontSize: "1rem",
          margin: 0,
        },
        cardTitle: {
          color: "#56464A",
          fontSize: "1.25rem",
          height: "56px",
          lineHeight: 1.3,
          fontWeight: 600,
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          wordBreak: "break-word",
          "&.MuiTypography-root": {
            fontSize: "1.25rem",
          },
        },
        cardContent: {
          padding: theme.spacing(2),
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          "&.MuiCardContent-root:last-child": {
            paddingBottom: 0,
          },
          "& .MuiTypography-root": {
            fontSize: "1rem",
          },
        },
        cardInfoContainer: {
          height: 42,
          position: "relative",
          marginTop: "8px",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          "& .MuiTypography-root": {
            fontSize: "1rem",
            color: "#948A8D",
          },
          "&::before": {
            content: "' '",
            position: "absolute",
            height: "1px",
            width: "100%",
            top: -4,
            background:
              "linear-gradient(290.55deg, #EEE7CC 0%, #AC8700 50%, #EEE7CC 100%)",
            visibility: "visible",
          },
        },
        venueLogoContainer: {
          display: "flex",
          position: "absolute",
          margin: theme.spacing(1.5, 2),
          bottom: 0,
          right: 0,
          "& .MuiCardMedia-root": {
            maxWidth: "90px",
            maxHeight: "43px",
          },
        },
        iconContainer: {
          width: "auto",
          marginRight: theme.spacing(1.5),
          "& .MuiSvgIcon-root": {
            height: "24px",
            width: "24px",
            color: theme.palette.primary.main,
          },
        },
        statusTextContainer: {
          width: "100%",
          backgroundColor: "#EFBB00",
          position: "absolute",
          padding: theme.spacing(0.75, 1.5),
          bottom: 0,
          left: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "52px",
        },
        statusText: {
          fontSize: "1.25rem",
          fontWeight: 700,
          color: theme.palette.primary.contrastText,
        },
        chipContainer: {
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          position: "absolute",
          padding: "5px 8px",
          zIndex: 1,
        },
        highlightTextChip: {
          height: "32px",
          display: "flex",
          padding: theme.spacing(0.5, 1.5),
          color: theme.palette.primary.contrastText,
          fontWeight: 700,
          marginRight: "auto",
          background: "linear-gradient(0deg, #AC8700 0%, #BA9B2A 88.96%)",
        },
        locationInfo: {
          maxWidth: "180px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 1,
          WebkitBoxOrient: "vertical",
        },
      },
    },
    EventPage: {
      defaultProps: {
        eventCarouselOption: {
          gap: "32px",
          autoWidth: true,
        },
      },
      styleOverrides: {
        ...NAV_PAGE_STYLE_OVERRIDES,
        emptyDataWrapper: {
          height: "826px",
        },
        carouselContainer: {
          gap: theme.spacing(2),
          "&:before": {
            content: "''",
            display: "inline-block",
            width: "113px",
            height: "934px",
            background: "linear-gradient(180deg, #F8F8FF, transparent);",
            maskImage:
              "linear-gradient(90deg, #000 0%, rgba(0, 0, 0, 0.00) 100%)",
            zIndex: 1,
            position: "absolute",
            top: 0,
            bottom: 0,
          },
          "&:after": {
            content: "''",
            display: "inline-block",
            width: "113px",
            height: "934px",
            background: "linear-gradient(90deg,transparent,#F8F8FF);",
            maskImage:
              "linear-gradient(180deg, #000 0%, rgba(0, 0, 0, 0.00) 100%)",
            zIndex: 1,
            position: "absolute",
            right: 0,
            top: 0,
            bottom: 0,
            left: "auto",
          },
          '[dir="rtl"] &': {
            "&:before": {
              background: "linear-gradient(270deg, #F8F8FF, transparent)",
              maskImage:
                "linear-gradient(270deg, #000 0%, rgba(0, 0, 0, 0.00) 100%)",
            },
            "&:after": {
              background: "linear-gradient(90deg, #F8F8FF, transparent)",
              maskImage:
                "linear-gradient(180deg, #000 0%, rgba(0, 0, 0, 0.00) 100%)",
            },
          },
        },
        carousel: {
          "& .splide": {
            margin: "0 auto",
            marginTop: theme.spacing(4.25),
          },
          "& .splide__pagination": {
            marginTop: theme.spacing(3),
          },
          "& .splide__pagination__page": {
            width: "16px",
            height: "16px",
          },
          "& .splide__pagination__page.is-active": {
            backgroundColor: theme.palette.primary.main,
            transition: `width ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut}, borderRadius ${theme.transitions.duration.standard}s ${theme.transitions.easing.easeInOut}`,
            transform: "none",
            width: "20px",
            height: "20px",
            borderRadius: "50%",
          },
          "& .splide__slide": {
            "&> *": {
              display: "inline-block",
              transform: "none",
              opacity: 0.6,
              transition: `all ${theme.transitions.duration.short}ms`,
            },
            "&.is-visible.is-active": {
              "&> *": {
                opacity: 1,
                transform: "none",
              },
            },
          },
        },
        venueSelector: {
          bottom: "8px",
          left: "50%",
          right: "unset",
          transform: "translateX(-50%)",
        },
      },
    },
    ServiceCard: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          borderRadius: "16px",
          overflow: "hidden",
          border: `1px solid ${theme.palette.divider}`,
          "&:first-of-type": {
            borderRadius: "16px",
          },
          "&:last-of-type": {
            borderRadius: "16px",
          },
          "&:before": {
            display: "none",
          },
          "&.Mui-expanded": {
            margin: 0,
          },
        },
        accordionSummary: {
          height: "282px",
          padding: theme.spacing(5, 3, 2.5),
          gap: theme.spacing(3),
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          alignItems: "flex-end",
          ":after": {
            content: "''",
            position: "absolute",
            top: 0,
            right: "-1px",
            left: "-1px",
            bottom: "-1px",
            zIndex: 0,
            background: `linear-gradient(180deg, rgba(255, 255, 255, 0.00) 19.68%, #FFF 67.87%)`,
          },
          "& .MuiAccordionSummary-expandIconWrapper": {
            color: theme.palette.text.secondary,
            marginBottom: theme.spacing(5),
            zIndex: 1,
            "& .MuiSvgIcon-root": {
              width: "24px",
              height: "24px",
            },
          },
          "& .MuiAccordionSummary-content": {
            margin: 0,
          },
        },
        coverImage: {
          backgroundPosition: "right center",
          backgroundRepeat: "no-repeat",
          backgroundColor: "#ffffffcc",
          backgroundBlendMode: "lighten",
          backgroundSize: "cover",
          filter: "grayscale(100%)",
          position: "absolute",
          top: 0,
          right: 0,
          bottom: 0,
          width: "60%",
        },
        summaryContainer: {
          display: "flex",
          flexDirection: "row",
          gap: theme.spacing(4),
          alignItems: "center",
          zIndex: 1,
        },
        titleText: {
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          WebkitLineClamp: 1,
          fontSize: "1.5rem",
          fontWeight: 700,
          color: theme.palette.primary.main,
          lineHeight: 1.1,
        },
        descriptionText: {
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 2,
          overflow: "hidden",
          wordBreak: "break-word",
          color: theme.palette.text.secondary,
          fontSize: "1.25rem",
          lineHeight: 1.1,
        },
        serviceIconContainer: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "64px",
          height: "64px",
          background: "#ECECED",
        },
        serviceIcon: {
          color: theme.palette.text.secondary,
          width: "40px",
          height: "40px",
        },
        infoContainer: {
          height: "84px",
          display: "flex",
          justifyContent: "flex-start",
          flexDirection: "column",
          gap: theme.spacing(1.5),
        },
        accordionDetails: {
          padding: theme.spacing(1.5),
          backgroundColor: theme.palette.primary.contrastText,
        },
        locationList: {
          padding: theme.spacing(0, 1.5),
          overflow: "hidden auto",
          maxHeight: "380px",
          "&::-webkit-scrollbar": {
            width: "4px",
          },
          "&::-webkit-scrollbar-track": {
            background: "transparent",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#8C8A94",
            borderRadius: "9999px",
          },
        },
        locationListItem: {
          height: "76px",
          borderBottom: `1px solid ${theme.palette.divider}`,
          padding: theme.spacing(2, 3.75, 2, 0),
          "&:last-of-type": {
            borderBottom: "none",
          },
          "&.ServiceCard-locationListItem--highlight": {
            padding: theme.spacing(2, 5.75, 2, 2),
            width: "calc(100% + 16px)",
            margin: theme.spacing(0, -1),
            borderRadius: "20px",
            border: "1px solid #C8AF55",
            background:
              "linear-gradient(333deg, rgba(200, 175, 85, 0.40) 31.92%, rgba(238, 231, 204, 0.40) 81.85%)",
            "& .ServiceCard-locationNavigateButton": {
              color: theme.palette.primary.main,
              marginRight: theme.spacing(-2),
            },
            "& .ServiceCard-listNameText": {
              color: theme.palette.primary.main,
              fontWeight: 700,
              fontSize: "1rem",
            },
            "& .ServiceCard-floorTextAvatar": {},
          },
        },
        locationNavigateButton: {
          color: theme.palette.text.secondary,
          marginRight: theme.spacing(-3),
          "& .MuiSvgIcon-root": {
            width: "24px",
            height: "24px",
          },
        },
        floorTextAvatar: {
          width: 32,
          height: 32,
          fontWeight: 700,
          color: theme.palette.primary.contrastText,
          borderRadius: "50%",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "0.875rem",
          display: "flex",
          marginLeft: "auto",
          lineHeight: 1.1,
          background:
            "url(https://s3.venue.in.th/level_Icon_b460ba199f.svg) , no-repeat",
        },
        venueLogo: {
          maxHeight: 32,
          maxWidth: 90,
          objectFit: "contain",
        },
        venueLogoWrapper: {
          width: 90,
          height: 32,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        locationLogoWrapper: {
          width: 32,
          height: 32,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginRight: theme.spacing(1.5),
        },
        locationLogo: {
          maxHeight: 32,
          maxWidth: 32,
          borderRadius: "4px",
        },
        divider: {
          border: "1px solid",
          height: "32px",
          margin: theme.spacing(0, 1.5),
          borderImage:
            "linear-gradient(to bottom, #EEE7CC 0%, #AC8700 50%, #EEE7CC 100%) 1",
        },
        listNameText: {
          fontSize: "1.1875rem",
          lineHeight: 1.1,
          color: theme.palette.text.secondary,
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          width: "188px",
        },
      },
    },
    ServicePage: {
      styleOverrides: {
        ...NAV_PAGE_STYLE_OVERRIDES,
        titleText: {
          color: theme.palette.primary.main,
          fontSize: "3rem",
          lineHeight: 1.12,
        },
        navigationWrapper: {
          marginBottom: `${mixins.kioskVNavigation.height}px`,
          bottom: 0,
        },
        actionButton: {
          display: "inline-flex",
        },
        venueSelector: {
          display: "block",
          position: "absolute",
          bottom: "8px",
          left: "50%",
          right: "unset",
          transform: "translateX(-50%)",
        },
      },
    },
    VuiDetailCard: {
      styleOverrides: {
        ...NAV_PAGE_STYLE_OVERRIDES,
        emptyDataContainer: {
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        buttonContainer: {
          position: "absolute",
          left: "50%",
          transform: "translateX(-50%)",
          display: "flex",
          justifyContent: "center",
          width: "100%",
          gap: theme.spacing(3),
          paddingTop: 0,
          height: "80px",
          margin: 0,
        },
        button: {
          minWidth: 188,
          height: "80px",
        },
        actionButton: {
          display: "inline-flex",
        },

        card: {
          display: "flex",
          gap: theme.spacing(4),
        },
        cardMediaWrapper: {
          width: "445px",
        },
        cardContentWrapper: {
          flex: 1,
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(5),
        },
        cardContent: {
          flexGrow: "initial",
        },
        galleryCarouselModal: {
          "&.VuiDetailCard-galleryCarouselModal--promotion,&.VuiDetailCard-galleryCarouselModal--event":
            {
              top: "auto",
              "& .MuiBackdrop-root": {
                top: "auto",
              },
              "& .AppImageCarouselModal-carousel": {
                "& .splide__arrows": {
                  top: "50%",
                  transform: "translateY(-50% + 42px)",
                },
              },
              "& .AppImageCarouselModal-image": {
                width: "542px",
                height: "963px",
              },
              "& .AppImageCarouselModal-carouselItem": {
                maxWidth: "566px",
              },
              "& .AppImageCarouselModal-closeButton": {
                top: "unset",
                bottom: "-104px",
              },
            },
        },
      },
    },
    DirectoryPage: {
      styleOverrides: {
        ...NAV_PAGE_STYLE_OVERRIDES,
        actionWrapper: {
          display: "flex",
        },
        root: {
          margin: theme.spacing(-8.5, 0, 0),
          gap: theme.spacing(1.5),
          "&:after": {
            content: "' '",
            position: "absolute",
            top: 730,
            bottom: 0,
            left: 0,
            right: 0,
            background:
              "linear-gradient(180deg, rgba(248, 248, 255, 0) 0%, #F8F8FF 100%)",
            height: "184px",
            pointerEvents: "none",
          },
        },
        contentBox: {
          display: "flex",
        },
        emptyDataWrapper: {
          minHeight: "900px",
          flex: 1,
        },
        gridItem: {
          width: "222px",
        },
        gridContainer: {
          gap: theme.spacing(2.5),
          padding: 0,
          paddingTop: theme.spacing(8.5),
          gridTemplateRows: "repeat(3, max-content)",
          minHeight: 0,
          height: "initial",
          gridAutoFlow: "row",
          overflow: "initial",
        },
        gridContainerWrapper: {
          height: "900px",
          overflow: "hidden auto",
          scrollbarWidth: "none",
          paddingBottom: theme.spacing(10),
        },
        filterSection: {
          height: "92px",
          maxWidth: "688px",
          "& .category-filterbar,& .subCategory-filterbar": {
            overflow: "hidden",
            maxWidth: "100%",
            padding: 0,
            margin: 0,
            "&:after": {
              width: "80px",
              background:
                "linear-gradient(270deg, #F8F8FF 0%, rgba(248, 248, 255, 0.00) 100%)",
              right: 0,
              pointerEvents: "none",
            },
            "&:before": {
              display: "none",
            },
          },
        },
        categoryFilterBar: {
          gap: theme.spacing(3),
        },
        subCategoryFilterBar: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "start",
          gap: theme.spacing(2),
          "& .CategoryFilterChip-icon": {
            display: "none",
          },
          "& .MuiToggleButton-root.MuiToggleButtonGroup-grouped": {
            borderRadius: "32px",
            width: "fit-content",
            "& .MuiSvgIcon-root": {
              display: "flex",
              margin: 0,
            },
          },
        },
        venueSelector: {
          bottom: "100px",
          left: "50%",
          right: "unset",
          transform: "translateX(-50%)",
        },
        actionContainer: {
          gap: theme.spacing(2),
          height: "92px",
          display: "flex",
          alignItems: "flex-end",
        },
      },
    },
    AppDining: {
      styleOverrides: {
        ...NAV_PAGE_STYLE_OVERRIDES,
        root: {
          margin: theme.spacing(-8.5, 0, 0),
          "&:after": {
            content: "' '",
            position: "absolute",
            top: 730,
            bottom: 0,
            left: 0,
            right: 0,
            background:
              "linear-gradient(180deg, rgba(248, 248, 255, 0) 0%, #F8F8FF 100%)",
            height: "184px",
            pointerEvents: "none",
          },
        },
        emptyDataContainer: {
          minHeight: "900px",
        },
        gridItem: {
          width: "223px",
          height: "345px",
        },
        gridContainer: {
          padding: 0,
          gap: theme.spacing(2.5),
          gridAutoFlow: "row",
          height: "initial",
          paddingTop: "68px",
          paddingBottom: "60px",
          overflow: "initial",
          gridTemplateRows: "repeat(4, max-content)",
          gridTemplateColumns: "repeat(4, max-content)",
        },
        gridContainerWrapper: {
          height: "900px",
          overflow: "hidden auto",
          scrollbarWidth: "none",
          paddingBottom: theme.spacing(5),
        },
        filterSection: {
          padding: 0,
          position: "absolute",
          left: 0,
          top: "unset",
          paddingLeft: theme.spacing(8),
          maxWidth: "688px",
          "& .subCategory-filterbar": {
            overflow: "hidden",
            maxWidth: "100%",
            padding: 0,
            margin: 0,
            "&:after": {
              display: "none",
            },
            "&:before": {
              display: "none",
            },
          },
        },
        filterButton: {
          gap: theme.spacing(1.5),
          "& .CategoryFilterChip-icon": {
            display: "none",
          },
        },
        filterContainer: {},
        venueSelector: {
          bottom: "100px",
          left: "50%",
          right: "unset",
          transform: "translateX(-50%)",
        },
      },
    },
    LuxuryPage: {
      styleOverrides: {
        root: {
          position: "absolute",
          width: "100%",
          height: "100%",
          left: 0,
        },
        actionButton: {
          minWidth: 128,
          backgroundColor: theme.palette.common.white,
          color: theme.palette.text.primary,
          "&:hover": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
          },
          "& .MuiSvgIcon-root": {
            marginRight: 0,
            width: 32,
            height: 32,
          },
        },
        actionContainer: {
          display: "flex",
          flexDirection: "row",
          gap: theme.spacing(1.5),
        },
        toolbarContainer: {
          position: "relative",
          display: "flex",
          gap: theme.spacing(3),
          ...NAV_PAGE_STYLE_OVERRIDES.toolbarContainer,
        },
        searchBarContainer: {
          width: "100%",
          height: 48,
          ...NAV_PAGE_STYLE_OVERRIDES.searchBarContainer,
        },
        emptyDataWrapper: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          paddingTop: 0,
          paddingBottom: 0,
          height: "810px", // Specifies the carousel height, inclusive of pagination
          position: "relative",
        },
        navigationWrapper: {
          zIndex: theme.zIndex.appBar,
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          padding: theme.spacing(0, 6.25),
          gap: theme.spacing(3),
          ...NAV_PAGE_STYLE_OVERRIDES.navigationWrapper,
          marginBottom: theme.spacing(37.5),
        },
        mainMenuContainer: {},
        swiperWrapper: {
          left: 0,
          width: "100%",
          height: "950px",
          overflow: "hidden",
          marginTop: "auto",
          "& .swiper": {
            maxWidth: "697px",
            height: "852px",
            alignItems: "flex-end",

            "& .swiper-wrapper": {
              alignItems: "flex-end",
              transitionTimingFunction: "ease-in-out",
            },

            "& .swiper-slide": {
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "1rem",
              color: "common.white",
              fontWeight: 700,
              fontSize: "2rem",
              transition: "all 0.5s ease",
              height: "85% !important",
              boxShadow:
                "0px 60px 74px 0px rgba(0, 0, 0, 0.01), 0px 45px 68px 0px rgba(0, 0, 0, 0.02), 0px 35px 57px 0px rgba(0, 0, 0, 0.05), 0px 25px 42px 0px rgba(0, 0, 0, 0.08), 0px 15px 23px 0px rgba(0, 0, 0, 0.10)",
            },
            "& .swiper-slide-active": {
              height: "100%  !important",
            },
          },
        },
      },
    },
    LuxuryCard: {
      styleOverrides: {
        root: {
          width: "100%",
          height: "100%",
          borderRadius: "4px",
          position: "relative",
          boxShadow: "none",
          "&.with-logo:before": {
            content: "''",
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "100%",
            height: "100%",
            opacity: 1,
            background:
              "linear-gradient(180deg, rgba(0, 0, 0, 0.00) 20%, #000 100.08%)",
            maskImage: "linear-gradient(to top, #000 20%, transparent)",
            WebkitMaskImage: "linear-gradient(to top, #000 20%, transparent)",
          },
        },
        cardMedia: {
          height: "100%",
          width: "100%",
        },
        logo: {
          zIndex: 1,
          height: "100%",
          width: "50%",
          position: "absolute",
          top: "80%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundSize: "contain",
        },
      },
    },
    LuxuryDetailPage: {
      styleOverrides: {
        ...NAV_PAGE_STYLE_OVERRIDES,
        root: {
          position: "absolute",
          top: "-1%",
          left: 0,
          width: "100%",
          height: "101%",
          zIndex: 10,
          backgroundColor: theme.palette.background.paper,
        },
        mainBox: {
          position: "relative",
          width: "100%",
          height: "100%",
          backgroundColor: theme.palette.background.paper,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          "&:before": {
            content: "''",
            position: "absolute",
            bottom: "-1px",
            left: 0,
            width: "100%",
            height: "100%",
            opacity: 1,
            background:
              "linear-gradient(180deg, rgba(0, 0, 0, 0.00) 55.08%, #000 100.08%)",
            maskImage: "linear-gradient(to top, #000 20%, transparent)",
            WebkitMaskImage: "linear-gradient(to top, #000 20%, transparent)",
          },
        },
        button: {
          minWidth: 188,
          height: "80px",
        },
        buttonContainer: {
          position: "absolute",
          right: 64,
          bottom: 40,
          paddingTop: 0,
          margin: 0,
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(4),
          alignItems: "end",
        },
        logoWrapper: {
          position: "absolute",
          left: 40,
          bottom: 40,
          "& img": {
            width: 300,
            height: "auto",
          },
        },
        cardMediaStyle: {
          width: "100%",
          height: "100%",
        },
        qrcodePrimaryText: {
          fontSize: "1rem",
          lineHeight: "1.2",
          fontWeight: 700,
          color: "#FFF",
          textAlign: "center",
        },
        qrcodeSecondaryText: {
          lineHeight: "1.2",
          fontSize: "1rem",
          color: "#FFF",
          textAlign: "center",
          fontWeight: 500,
        },
      },
    },
    CarouselNavigation: {
      defaultProps: {
        carouselOption: {
          width: `${mixins.kioskVNavigation.width}px`,
        },
      },
      styleOverrides: {
        root: {
          margin: theme.spacing(0, 8, 2),
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          display: "flex",
          justifyContent: "center",
          maskImage:
            "linear-gradient(to right, transparent, black 8%, black 88%, transparent)",
          "&.ics .CarouselNavigation-carouselItem[link^='/luxury']": {
            pointerEvents: "none",
            "& .CarouselNavigationMenu-root": {
              color: "#C6C5C9",
              "&:before": {
                border: "1px solid #E2E2E4",
                background: "#E2E2E4",
              },
              "& .MuiSvgIcon-root *": {
                fill: "currentColor",
              },
              "& .MuiBottomNavigationAction-label": {
                color: "inherit",
              },
            },
          },
        },
        carousel: {
          "& .splide__track": {
            margin: 0,
            padding: 0,
          },
        },
        carouselItem: {
          "&.is-active": {
            zIndex: 1,
          },
          "&:not(.is-visible)": {
            opacity: 0,
          },
          "&.is-move": {
            opacity: 1,
          },
        },
      },
    },
    CarouselNavigationMenu: {
      styleOverrides: {
        root: {
          padding: 0,
          maxWidth: "160px",
          width: "160px",
          height: `${mixins.kioskVNavigation.height}px`,
          margin: theme.spacing(0, -2),
          "& .MuiSvgIcon-root": {
            transition: "width 250ms ease, height 250ms ease",
            width: "48px",
            height: "48px",
            margin: 0,
          },
          "& .MuiBottomNavigationAction-label": {
            transition: "all 250ms ease",
            position: "absolute",
            fontSize: "1.125rem",
            textTransform: "capitalize",
            color: theme.palette.text.primary,
            opacity: 1,
            bottom: "15px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 1,
            WebkitBoxOrient: "vertical",
            lineHeight: 1.8,
          },
          "&:before": {
            transition: "width 250ms ease, height 250ms ease",
            content: "''",
            zIndex: -1,
            position: "absolute",
            width: "108px",
            height: "108px",
            transform: "rotate(-45deg)",
            borderRadius: "24px",
            border: "1px solid #C8AF55",
            background: theme.palette.background.paper,
            boxShadow:
              "33px 36px 14px 0px rgba(0, 0, 0, 0.00), 21px 23px 13px 0px rgba(0, 0, 0, 0.01), 12px 13px 11px 0px rgba(0, 0, 0, 0.04), 5px 6px 8px 0px rgba(0, 0, 0, 0.06), 1px 1px 4px 0px rgba(0, 0, 0, 0.07)",
          },
          "& .MuiTouchRipple-root": {
            width: "120px",
            height: "120px",
            borderRadius: "24px",
            transform: "rotate(-45deg)",
            margin: "auto",
          },
          "&.Mui-selected": {
            zIndex: 1,
            color: theme.palette.primary.main,
            backgroundColor: "transparent",
            "& .MuiBottomNavigationAction-label": {
              fontSize: "1.375rem",
              fontWeight: 700,
              color: theme.palette.primary.main,
              bottom: "-10px",
            },
            "&:before": {
              content: "''",
              zIndex: -1,
              position: "absolute",
              width: "132px",
              height: "132px",
              transform: "rotate(-45deg)",
              borderRadius: "24px",
              borderBottom: "5px solid #ccb561",
              background:
                "url(https://s3.venue.in.th/pattern_menu_08c025162a.png) no-repeat center center / cover, linear-gradient(15deg, #AC8700 5.88%, #E9CA76 84.96%), linear-gradient(15deg, #AC8700 5.88%, #C8AF55 84.96%)",
              boxShadow:
                "33px 36px 14px 0px rgba(0, 0, 0, 0.00), 21px 23px 13px 0px rgba(0, 0, 0, 0.01), 12px 13px 11px 0px rgba(0, 0, 0, 0.04), 5px 6px 8px 0px rgba(0, 0, 0, 0.06), 1px 1px 4px 0px rgba(0, 0, 0, 0.07)",
            },
            "& .MuiSvgIcon-root": {
              width: "72px",
              height: "72px",
            },
          },
        },
      },
    },
    HomePage: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "column",
          height: "100%",
        },
        fullscreenLayout: {
          backgroundColor: "transparent",
          position: "relative",
          flex: 1,
          zIndex: theme.zIndex.appBar - 1,
        },
        contentContainer: {
          display: "flex",
          flexDirection: "column",
          height: "100%",
          zIndex: -1,
        },
        welcomeContainer: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          height: "100%",
          zIndex: 2,
          "::after": {
            content: "''",
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            opacity: 0.6,
            background:
              "linear-gradient(39deg, #C8AF55 25.16%, #EEE7CC 72.67%)",
          },
        },
        actionContainer: {
          marginTop: 0,
          display: "flex",
          justifyContent: "center",
          width: "100%",
          opacity: 1,
        },
        actionButton: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          borderTop: "2px solid transparent",
          borderBottom: "2px solid transparent",
          borderImage:
            "linear-gradient(270deg, rgba(238, 231, 204, 0.00) 2.25%, #AC8700 52.88%, rgba(238, 231, 204, 0.00) 100%) 1",
          gap: theme.spacing(2),
          background:
            "radial-gradient(50% 921.97% at 50% 50%, #EEE7CC 0%, rgba(238, 231, 204, 0) 100%);",
          borderRadius: "0",
          width: "65%",
          zIndex: 3,
          position: "relative",
          overflow: "hidden",
          "::before": {
            content: "''",
            position: "absolute",
            top: 25,
            left: "49%",
            width: "80px",
            height: "80px",
            transform: "translate(-50%, -50%)",
            background:
              "radial-gradient(circle, rgba(255, 255, 255, 0.90) 0%, rgba(255, 255, 255, 0.7) 20%, rgba(255, 255, 255, 0.4) 40%, rgba(255, 255, 255, 0) 70%)",
            pointerEvents: "none",
            borderRadius: "50%",
            zIndex: 3,
          },
        },
        touchToStartIcon: {
          width: 88,
          height: 88,
          color: theme.palette.primary.main,
        },
        touchToStartText: {
          fontSize: "2.5rem",
          fontWeight: 500,
          textTransform: "uppercase",
          color: theme.palette.primary.main,
        },
        touchTriggerArea: {
          position: "fixed",
          left: 0,
          right: 0,
          bottom: 0,
          top: 0,
          zIndex: 99999,
        },
      },
    },
    AppDirectionOverview: {
      styleOverrides: {
        container: {
          bottom: "64px",
          margin: theme.spacing(0, 8),
          "& .MuiPaper-root": {
            borderRadius: "32px",
          },
        },
        ordinalSelectorWrapper: {
          left: "unset",
          right: "-20px",
          top: "-162px",
          "& .MuiList-root": {
            flexDirection: "column-reverse",
          },
        },
        locationButtonContainer: {
          display: "flex",
          position: "absolute",
          flexDirection: "column",
          gap: theme.spacing(2.5),
          right: "-20px",
          top: "-146px",
        },
        actionButtonWrapper: {
          position: "absolute",
          display: "flex",
          width: "100%",
          justifyContent: "space-between",
        },
        backButton: {
          display: "none",
        },
        exitButton: {
          boxShadow: "none",
          display: "flex",
          top: "-34px",
          right: "-34px",
          backgroundColor: theme.palette.background.default,
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: "64px",
          width: "82px",
          height: "82px",
          "& .MuiButton-startIcon": {
            margin: 0,
            "& .MuiSvgIcon-root": {
              width: 24,
              height: 24,
              fill: theme.palette.text.secondary,
            },
          },
          ":hover": {
            backgroundColor: theme.palette.background.default,
          },
        },
        directionOverviewContainer: {
          width: "100%",
          border: `1px solid ${theme.palette.divider}`,
          boxShadow:
            "33px 36px 14px 0px rgba(0, 0, 0, 0.00), 21px 23px 13px 0px rgba(0, 0, 0, 0.01), 12px 13px 11px 0px rgba(0, 0, 0, 0.04), 5px 6px 8px 0px rgba(0, 0, 0, 0.06), 1px 1px 4px 0px rgba(0, 0, 0, 0.07)",
          borderRadius: "32px",
        },
        wrapper: {
          padding: theme.spacing(12.75, 5, 3),
          borderRadius: "32px",
          border: "1px solid transparent",
          background:
            "linear-gradient(180deg, #FFFFFF 71%, #EDEEEE 100%, #FFF) padding-box, linear-gradient(333deg, #D6C380 30%, #EEE7CC 81.85%) border-box",
        },
        directionContentWrapper: {},
        directionSummaryContainer: {
          width: "100%",
        },
        durationText: {
          fontSize: "3rem",
          fontWeight: 700,
          lineHeight: 1,
        },
        distanceText: {
          color: theme.palette.text.secondary,
          fontSize: "1.5rem",
          lineHeight: 1,
          paddingTop: theme.spacing(1),
        },
        divider: {
          marginTop: theme.spacing(3),
          width: "80%",
          borderBottomWidth: "1px",
          borderImage:
            "linear-gradient(291deg, #EEE7CC 0%, #AC8700 50%, #EEE7CC 100%) 1",
        },
        locationSummaryContainer: {
          display: "flex",
          alignItems: "center",
          gap: theme.spacing(1.5),
          marginTop: theme.spacing(2),
        },
        locationContainer: {
          display: "flex",
          marginTop: theme.spacing(3),
          gap: theme.spacing(1.5),
        },
        locationText: {
          display: "flex",
          alignItems: "center",
          fontSize: "1.25rem",
          color: theme.palette.text.primary,
          fontWeight: 700,
        },
        directionSummaryArrowContainer: {
          display: "flex",
          alignItems: "center",
          marginTop: theme.spacing(3),
          "& .MuiSvgIcon-root": {
            width: 30,
            height: 30,
            fill: theme.palette.text.secondary,
          },
        },
        qrCodeContainer: {
          position: "absolute",
          top: 62,
          right: 40,
          boxShadow: "none",
          margin: 0,
          backgroundColor: "transparent",
          width: "124px",
          height: "190px",
          justifyContent: "flex-start",
          padding: 0,
          border: 0,
          "&.AppQRCode-root": {
            borderRadius: 0,
          },
          "& .AppQRCode-content": {
            width: "124px",
            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            border: "1px solid #E9E9E9",
            padding: "14px",
            ":before": {
              display: "none",
            },
            ":after": {
              display: "none",
            },
          },
          "& .AppQRCode-qrcode": {
            width: "100%",
            height: "100%",
            border: "none",
          },
          "& .AppQRCode-caption": {
            fontWeight: 700,
            fontSize: "1.25rem",
            color: theme.palette.text.primary,
          },
          "& .AppQRCode-secondary-caption": {
            fontWeight: 400,
            fontSize: "1rem",
            color: theme.palette.text.primary,
          },
        },
        startText: {
          fontSize: "1.25rem",
          color: theme.palette.text.secondary,
          display: "flex",
          alignItems: "center",
        },
        venueLogoContainer: {
          display: "inline-flex",
          width: "80px",
          height: "40px",
          padding: theme.spacing(1),
          backgroundColor: "#F4F3F3",
          borderRadius: "16px",
        },
        venueLogo: {
          width: "100%",
          height: "100%",
          backgroundSize: "contain",
        },
        stepOverviewContainer: {
          border: "1px solid transparent",
          background:
            "linear-gradient(180deg, #FFFFFF 71%, #EDEEEE 100%, #FFF) padding-box, linear-gradient(333deg, #D6C380 30%, #EEE7CC 81.85%) border-box",
          borderRadius: "32px",
          boxShadow:
            "33px 36px 14px 0px rgba(0, 0, 0, 0.00), 21px 23px 13px 0px rgba(0, 0, 0, 0.01), 12px 13px 11px 0px rgba(0, 0, 0, 0.04), 5px 6px 8px 0px rgba(0, 0, 0, 0.06), 1px 1px 4px 0px rgba(0, 0, 0, 0.07)",
          "::after": {
            display: "none",
          },
          minHeight: "406px",
        },
        stepOverviewExitButton: {
          boxShadow: "none",
          display: "flex",
          top: "-34px",
          right: "-34px",
          zIndex: 9999,
          backgroundColor: theme.palette.background.default,
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: "64px",
          width: "82px",
          height: "82px",
          marginLeft: "auto",
          "& .MuiButton-startIcon": {
            margin: 0,
            "& .MuiSvgIcon-root": {
              width: 24,
              height: 24,
              fill: theme.palette.text.secondary,
            },
          },
          ":hover": {
            backgroundColor: theme.palette.background.default,
          },
        },
        stepper: {
          "& .MuiTypography-root": {
            "&.MuiListItemText-primary": {
              fontSize: "1.25rem",
              color: theme.palette.text.secondary,
            },
            "&.MuiListItemText-secondary": {
              display: "none",
            },
            "& .MuiTypography-subTitle": {
              color: theme.palette.text.primary,
              fontWeight: 700,
            },
          },
          padding: theme.spacing(1, 8.5, 0),
          "& .MuiStep-vertical:not(:last-of-type) .MuiStepLabel-labelContainer":
            {
              borderBottom: "1px solid #E7E8E8",
              paddingTop: theme.spacing(3),
              paddingBottom: theme.spacing(3),
            },
          "& .MuiStep-vertical:first-of-type .MuiStepLabel-labelContainer": {
            paddingTop: theme.spacing(3),
          },
          "& .MuiStepConnector-line": {
            display: "flex",
            backgroundImage:
              "radial-gradient(ellipse, #C6C5C9 40%, transparent 50%)",
            backgroundSize: "4px 8px",
            borderLeft: "4px solid transparent",
            width: "4px",
            position: "absolute",
            top: "-20px",
            left: "-22px",
            minHeight: "40px",
          },
          "& .MuiStep-vertical": {
            ":last-of-type": {
              borderBottom: "none",
              paddingTop: theme.spacing(3),
              marginLeft: theme.spacing(-0.75),
              "& .MuiStepLabel-IconContainer": {
                paddingRight: theme.spacing(3.75),
              },
              "& .MuiSvgIcon-root": {
                width: 40,
                height: 40,
              },
            },
            "& .MuiStepLabel-labelContainer": {
              padding: 0,
            },
            ":first-of-type": {
              "& .MuiStepLabel-labelContainer": {
                paddingTop: 0,
              },
              "& .MuiSvgIcon-root": {
                width: 40,
                height: 40,
              },
            },
            "& .MuiStepLabel-iconContainer": {
              "& .MuiSvgIcon-root": {
                zIndex: 9999,
                color: "#C6C5C9",
              },
            },
          },
          "& .MuiStepConnector-root": {
            marginLeft: theme.spacing(5),
            position: "relative",
          },
        },
      },
    },
    DirectionCardActions: {
      styleOverrides: {
        root: {
          flexDirection: "row-reverse",
          justifyContent: "center",
        },
        actionButton: {
          fontWeight: 500,
          fontSize: "1.25rem",
          height: "80px",
          width: "200px",
          borderRadius: "16px",
        },
      },
    },
    AppDirectionSearch: {
      styleOverrides: {
        paper: {
          display: "inline-flex",
          height: "52px",
          borderRadius: "9999px",
          padding: theme.spacing(1.5, 2.5),
          marginTop: theme.spacing(4),
          marginLeft: theme.spacing(5),
          boxShadow: "none",
          border: `1px solid ${theme.palette.divider}`,
        },
        formControlLabel: {
          flexDirection: "row-reverse",
          gap: theme.spacing(1.25),
          "& .MuiFormControlLabel-label": {
            marginLeft: 0,
            fontSize: "1.25rem",
            fontWeight: 400,
            textTransform: "capitalize",
            color: theme.palette.text.secondary,
          },
        },
      },
    },
    DirectionStep: {
      styleOverrides: {
        originIcon: {
          width: 40,
          height: 40,
        },
        destinationIcon: {
          width: 40,
          height: 40,
        },
      },
    },
    MyLocationButton: {
      styleOverrides: {
        root: {
          width: "80px",
          height: "80px",
          padding: theme.spacing(2.25),
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: "24px",
          boxShadow:
            "2px 2px 6px rgba(0, 0, 0, 0.07),10px 12px 10px rgba(0, 0, 0, 0.04), 20px 22px 12px rgba(0, 0, 0, 0.02)",
        },
        icon: {
          width: "44px",
          height: "44px",
          fill: theme.palette.text.secondary,
        },
      },
    },
    AppNavigationStep: {
      styleOverrides: {
        title: {
          display: "none",
        },
        primaryText: {
          fontSize: "1.5rem",
          color: theme.palette.text.secondary,
          fontWeight: 400,
        },
        highlightedText: {
          color: theme.palette.text.primary,
          fontWeight: 700,
        },
        originIconContainer: {
          width: "96px",
          marginTop: theme.spacing(5.5),
          justifyContent: "unset",
          gap: theme.spacing(1),
          "& .MuiSvgIcon-root": {
            width: "1em",
            height: "1em",
          },
        },
        progressBar: {
          alignItems: "unset",
          justifyContent: "center",
        },
        locationText: {
          marginTop: 0,
          flexGrow: 1,
          fontSize: "1rem",
          paddingRight: 0,
          color: theme.palette.text.primary,
          textTransform: "unset",
        },
        wrapper: {
          margin: theme.spacing(0, 8, 8),
        },
        navButton: {
          height: 80,
          width: 200,
          fontWeight: 400,
        },
        container: {
          border: "1px solid transparent",
          background:
            "linear-gradient(180deg, #FFFFFF 71%, #EDEEEE 100%, #FFF) padding-box, linear-gradient(333deg, #D6C380 30%, #EEE7CC 81.85%) border-box",
          boxShadow:
            "33px 36px 14px 0px rgba(0, 0, 0, 0.00), 21px 23px 13px 0px rgba(0, 0, 0, 0.01), 12px 13px 11px 0px rgba(0, 0, 0, 0.04), 5px 6px 8px 0px rgba(0, 0, 0, 0.06), 1px 1px 4px 0px rgba(0, 0, 0, 0.07)",
          borderRadius: "32px",
          height: "438px",
          padding: theme.spacing(8, 5, 3),
        },
        kioskBackButton: {
          display: "none",
        },
        exitButtonWrapper: {
          display: "flex",
        },
        exitButton: {
          top: "-34px",
          right: "-34px",
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: "64px",
          width: "82px",
          height: "82px",
          "& .MuiSvgIcon-root": {
            fill: theme.palette.text.secondary,
            height: 24,
            width: 24,
          },
          "& .MuiButton-startIcon": {
            marginX: 0,
          },
        },
        originAvatar: {
          backgroundColor: "transparent",
          borderRadius: 0,
          width: 96,
          height: 60,
          "& .MuiAvatar-img": {
            objectFit: "cover",
          },
        },
        destinationAvatar: {
          backgroundColor: theme.palette.background.paper,
          borderRadius: 0,
          width: "auto",
          height: 60,
          order: 0,
          "& .MuiAvatar-img": {
            objectFit: "cover",
          },
          "& .MuiSvgIcon-root": {
            fill: "#002F87",
          },
        },
        destinationIcon: {
          width: 45,
          height: 55,
        },
        venueLogoContainer: {
          display: "none",
        },
        actionButtonWrapper: {
          position: "absolute",
          zIndex: 9999,
          padding: theme.spacing(1.25),
          justifyContent: "flex-end",
        },
        destinationIconContainer: {
          marginTop: theme.spacing(5.5),
          justifyContent: "unset",
          gap: theme.spacing(1),
          width: "96px",
          "& .MuiTypography-root": {
            paddingRight: 0,
          },
        },
        navButtonWrapper: {
          gap: theme.spacing(2),
        },
        ordinalSelectorWrapper: {
          left: "unset",
          transform: "unset",
          right: "-20px",
          top: "-146px",
        },
        stepProgressBar: {
          padding: 0,
          marginTop: theme.spacing(5.5),
          height: "64px",
          justifyContent: "center",
        },
        cooldownProgress: {
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          padding: theme.spacing(0, 1.5),
          "& .CoolDownProgress-linearProgress": {
            height: "10px",
            borderBottomRightRadius: "32px",
            borderBottomLeftRadius: "32px",
          },
        },
      },
    },
    StepProgressBar: {
      styleOverrides: {
        connector: {
          "& .MuiStepConnector-line": {
            margin: theme.spacing(0.25),
            backgroundColor: "transparent",
            backgroundImage:
              "radial-gradient(circle, #E4E2E3 50%, transparent 50%)",
            backgroundSize: "15px",
            borderColor: "transparent",
            height: "4px",
          },
          "&.Mui-active": {
            "& .MuiStepConnector-line": {
              height: "4px",
              backgroundImage: "none",
              backgroundColor: theme.palette.primary.main,
            },
          },
          "&.Mui-completed": {
            "& .MuiStepConnector-line": {
              height: "4px",
              backgroundImage: "none",
              backgroundColor: theme.palette.primary.main,
            },
          },
        },
        stepper: {
          "& .MuiStepLabel-iconContainer": {
            ".step": {
              backgroundColor: "#C9C5C6",
              width: "40px",
              height: "40px",
            },
            "&.Mui-active": {
              ".step": {
                backgroundColor: theme.palette.primary.main,
                width: "40px",
                height: "40px",
              },
            },
            "&.Mui-completed": {
              ".step": {
                backgroundColor: theme.palette.primary.main,
                width: "40px",
                height: "40px",
              },
            },
          },
        },
      },
    },
    FeatureCard: {
      defaultProps: {
        galleryCarouselOption: {
          arrowPath: "M31 19.4983L10 3L20.4966 19.4983L10 36L31 19.4983Z",
        },
      },
      styleOverrides: {
        root: {
          width: "unset",
          padding: theme.spacing(5, 4, 4),
          borderRadius: "32px",
          boxShadow:
            "33px 36px 14px 0px rgba(0, 0, 0, 0.00), 21px 23px 13px 0px rgba(0, 0, 0, 0.01), 12px 13px 11px 0px rgba(0, 0, 0, 0.04),5px 6px 8px 0px rgba(0, 0, 0, 0.06),1px 1px 4px 0px rgba(0, 0, 0, 0.07)",
          border: "1px solid transparent",
          background:
            "linear-gradient(180deg, #FFFFFF 71%, #EDEEEE 100%, #FFF) padding-box, linear-gradient(333deg, #D6C380 30%, #EEE7CC 81.85%) border-box",
          flexDirection: "column",
          minHeight: "480px",
          margin: theme.spacing(0, 8, 8),
        },
        primarySection: {
          padding: theme.spacing(0, 3, 0, 0),
          height: "auto",
          borderRight: "1px solid",
          borderImage:
            "linear-gradient(  to bottom,  rgba(0, 0, 0, 0) 0%, #C8AF55 30%, #C8AF55 70%,  rgba(0, 0, 0, 0) 100%) 1 100%",
        },
        secondarySection: {
          alignItems: "flex-start",
          justifyContent: "flex-start",
          padding: theme.spacing(0, 2, 0, 3),
          gap: theme.spacing(2),
        },
        header: {
          display: "flex",
          flexDirection: "row",
          gap: theme.spacing(2),
          justifyContent: "flex-start",
          alignItems: "flex-start",
          marginBottom: theme.spacing(1.75),
        },
        content: {
          height: "68px",
          maxWidth: "520px",
          lineHeight: "1.2",
          marginBottom: theme.spacing(1),
          "&::-webkit-scrollbar": {
            width: "8px",
          },
          "&::-webkit-scrollbar-track": {
            background: "transparent",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#8C8A94",
          },
        },
        avatar: {
          width: "90px",
          height: "90px",
          borderRadius: "12px",
          border: `1px solid ${theme.palette.divider}`,
          color: theme.palette.text.secondary,
        },
        labelContainer: {
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: theme.spacing(1.25),
        },
        label: {
          color: theme.palette.text.primary,
          fontSize: "1.25rem",
          fontWeight: 700,
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 2,
          overflow: "hidden",
          wordBreak: "break-word",
          lineHeight: "1.3",
        },
        actionContainer: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          gap: theme.spacing(1.5),
        },
        actionButton: {
          flex: "1 1 100%",
          maxWidth: "214px",
          height: "80px",
        },
        listContainer: {
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: theme.spacing(1),
        },
        qrCodeContainer: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: theme.spacing(1),
        },
        qrCode: {},
        qrcodePrimaryText: {
          fontSize: "1rem",
          lineHeight: "1.2",
          fontWeight: 700,
          color: theme.palette.text.primary,
        },
        qrcodeSecondaryText: {
          lineHeight: "1.2",
          fontSize: "1rem",
          color: theme.palette.text.primary,
        },
        carousel: {
          "& .splide": {
            width: "100%",
          },
          "& .splide__track": {
            padding: 0,
            margin: 0,
            width: "100%",
          },
          "& .splide__list": {
            width: "100%",
          },
          "& .splide__slide": {
            diplay: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "100%",
          },
          "& img": {
            width: "100%",
            height: "100%",
            borderRadius: "4px",
            objectFit: "cover",
          },
          "& .splide__arrow": {
            width: "32px",
            height: "32px",
            background: "#F8F8FF",
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2,
            opacity: 1,
            transition: "opacity 0.15s ease-in-out",
            color: theme.palette.text.secondary,
            "& svg": {
              width: "16px",
              height: "16px",
              fill: "currentColor",
            },
            "&:disabled": {
              opacity: 0,
              pointerEvents: "none",
            },
          },
          "& .splide__arrow--next": {
            right: 50,
          },
          "& .splide__arrow--prev": {
            left: 50,
          },
          "& .splide__pagination": {
            display: "none",
          },
        },
        closeButton: {
          top: "-40px",
          right: "40px",
          padding: 0,
          width: "82px",
          height: "82px",
          borderRadius: "50%",
          backgroundColor: "#F8F8FF",
          border: `1px solid ${theme.palette.divider}`,
          "& .MuiSvgIcon-root": {
            width: "24px",
            height: "24px",
            color: "#8C8A94",
          },
          "&:hover": {
            backgroundColor: "#F8F8FF",
          },
        },
        categoryLabel: {
          " .VuiDescriptionList-contentText": {
            textAlign: "left",
            wordBreak: "break-word",
          },
        },
        operationTimeLabel: {},
        openingLabel: {},
        contentWrapper: {
          display: "grid",
          width: "100%",
          height: "292",
          background: theme.palette.paper,
          minHeight: "0px",
          overflow: "hidden",
          gridTemplateColumns: "2fr 1fr",
          "&.content-with-gallery": {
            gridTemplateColumns: "1fr 1fr 360px",
          },
        },
        imageSection: {},
        headerImage: {
          height: "78px",
          width: "164px",
          objectFit: "contain",
        },
        galleryImage: {},
        listItem: {
          display: "flex",
          flexDirection: "row",
          gap: theme.spacing(1),
          "&.is-coming-soon": {
            "& > *,& .VuiDescriptionList-root > *": {
              color: theme.palette.error.main,
            },
          },
        },
        statusContainer: {
          display: "flex",
          flexDirection: "row",
          gap: theme.spacing(1),
        },
        newShopChip: {},
        comingSoonChip: {},
        vatRefundContainer: {
          display: "flex",
          marginTop: theme.spacing(-1),
        },
        vatRefundChip: {},
        galleryCarouselModal: {
          "&.FeatureCard-galleryCarouselModal": {
            top: "auto",
            "& .MuiBackdrop-root": {
              top: "auto",
            },
            "& .AppImageCarouselModal-image": {
              width: "880px",
              height: "587px",
            },
            "& .AppImageCarouselModal-carouselItem": {
              maxWidth: "914px",
            },
          },
        },
      },
    },
    ScrollableTab: {
      styleOverrides: {
        root: {},
        scrollContainer: {
          display: "flex",
          alignItems: "center",
          position: "relative",
          "& .MuiTabs-scroller": {
            minHeight: "unset",
          },
          "& .MuiTabs-indicator": {
            display: "none",
          },
          "& .MuiTabs-scrollButtons": {
            display: "flex",
            zIndex: 2,
            "&.Mui-disabled": {
              opacity: 0,
              visibility: "hidden",
            },
          },
          "&:not(.MuiTabs-vertical) .MuiTabs-scrollButtons": {
            position: "absolute",
            top: "unset",
            "&:first-of-type": {
              left: 0,
            },
            "&:last-of-type": {
              right: 0,
            },
          },
          "&.MuiTabs-vertical .MuiTabs-scrollButtons": {
            transform: "rotate(90deg)",
            position: "absolute",
            "&:first-of-type": {
              top: 0,
            },
            "&:last-of-type": {
              bottom: 0,
            },
          },
        },
        iconButton: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 40,
          height: 40,
          backgroundColor: theme.palette.background.paper,
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: "50%",
          fill: theme.palette.text.secondary,
          "&:hover": {
            backgroundColor: theme.palette.background.paper,
          },
        },
      },
    },
    SubCategorySidebar: {
      styleOverrides: {
        root: {
          width: "222px",
          height: "816px",
          backgroundColor: theme.palette.background.paper,
          border: `1px solid ${theme.palette.divider}`,
          marginTop: theme.spacing(6),
          borderRadius: "24px",
          boxShadow:
            "29px 28px 11px 0px rgba(0, 0, 0, 0.00), 18px 18px 10px 0px rgba(0, 0, 0, 0.01), 10px 10px 9px 0px rgba(0, 0, 0, 0.02), 5px 4px 6px 0px rgba(0, 0, 0, 0.04), 1px 1px 4px 0px rgba(0, 0, 0, 0.04);",
          padding: theme.spacing(2.5),
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(4),
          transformOrigin: "left center",
          zIndex: 10,
        },
        mainCategoryWrapper: {
          minWidth: "182px",
          minHeight: "182px",
          background:
            "linear-gradient(333deg, rgba(200, 175, 85, 0.40) 9.48%, rgba(238, 231, 204, 0.40) 69.55%)",
          borderRadius: "16px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: theme.spacing(1),
          padding: theme.spacing(1.5),
        },
        mainCategoryLabel: {
          textAlign: "center",
          fontWeight: 700,
          color: theme.palette.primary.main,
        },
        icon: {
          "& .MuiSvgIcon-root": {
            width: "60px",
            height: "60px",
            fill: theme.palette.primary.main,
          },
        },
        subCategoryWrapper: {
          overflowX: "hidden",
          overflowY: "auto",
          "&::-webkit-scrollbar": {
            width: "4px",
          },
          "&::-webkit-scrollbar-track": {
            background: "transparent",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#8C8A94",
            borderRadius: "9999px",
          },
          "& .MuiToggleButton-root": {
            height: "auto",
            minHeight: "40px",
            width: "fit-content",
            textAlign: "left",
            "& .MuiTypography-root": {
              whiteSpace: "normal",
              wordBreak: "break-word",
              lineHeight: 1.2,
            },
          },
        },
      },
    },
    OrdinalSelector: {
      defaultProps: {
        popoverProps: {
          slotProps: {
            backdrop: {
              sx: { background: "transparent" },
            },
          },
          anchorOrigin: {
            vertical: "center",
            horizontal: "left",
          },
          transformOrigin: {
            vertical: "center",
            horizontal: "right",
          },
        },
        popperProps: {
          // [@Doc](https://mui.com/material-ui/react-popper/#scroll-playground)
          modifiers: [
            {
              name: "preventOverflow",
              enabled: false,
            },
            {
              name: "offset",
              options: {
                offset: [0, -14],
              },
            },
          ],
        },
      },
      styleOverrides: {
        root: {
          "&:after": {
            pointerEvents: "none",
            position: "absolute",
            bottom: 0,
            opacity: 0,
            right: "65px",
            content: "''",
            background: theme.palette.background.paper,
            width: "0",
            height: "84px",
            transition: `all ${theme.transitions.duration.standard}ms ${theme.transitions.easing.easeInOut}, borderRadius ${theme.transitions.duration.standard}s ${theme.transitions.easing.easeInOut}`,
            clipPath:
              "path('M0 0.613281C0.000148435 12.4251 9.57494 21.9999 21.3867 22C28.9077 22 35.5943 17.6887 41.2393 12.7188C42.4301 11.67 43.6868 10.6948 45 9.7959V74.2031C43.687 73.3043 42.43 72.3298 41.2393 71.2812C35.5943 66.3113 28.9077 62 21.3867 62C9.57494 62.0001 0.000148426 71.5749 0 83.3867V0.613281Z')",
            zIndex: theme.zIndex.modal + 1,
          },
          "&.is-open": {
            "&:after": {
              opacity: 1,
              width: "45px",
              height: "84px",
            },
          },
        },
        openButton: {
          backgroundColor: theme.palette.background.paper,
          border: `1px solid ${theme.palette.divider}`,
          width: "86px",
          height: "138px",
          display: "flex",
          zIndex: theme.zIndex.modal + 2,
          borderRadius: "9999px",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          padding: theme.spacing(1.5),
          gap: theme.spacing(1.25),
          transition: `all ${theme.transitions.duration.standard}ms ${theme.transitions.easing.easeInOut}`,
          boxShadow:
            "0px 45px 13px 0px rgba(0, 0, 0, 0.00), 0px 29px 11px 0px rgba(0, 0, 0, 0.01), 0px 16px 10px 0px rgba(0, 0, 0, 0.05), 0px 7px 7px 0px rgba(0, 0, 0, 0.09), 0px 2px 4px 0px rgba(0, 0, 0, 0.10)",
          "&:hover": {
            backgroundColor: theme.palette.background.paper,
            border: `1px solid ${theme.palette.divider}`,
          },
          "&.is-open": {
            backgroundColor: theme.palette.background.default,
            height: "82px",
            width: "82px",
            "& .OrdinalSelector-openIconWrapper": {
              display: "none",
            },
            "& .OrdinalSelector-floorAvatar": {
              display: "none",
            },
            "& .OrdinalSelector-closeIconWrapper": {
              display: "inline-flex",
              color: theme.palette.text.secondary,
            },
          },
        },
        popoverRoot: {
          "& .MuiPaper-root": {
            width: "200px",
            height: "591px",
            boxShadow:
              " 0px 45px 13px 0px rgba(0, 0, 0, 0.00), 0px 29px 11px 0px rgba(0, 0, 0, 0.01), 0px 16px 10px 0px rgba(0, 0, 0, 0.05), 0px 7px 7px 0px rgba(0, 0, 0, 0.09), 0px 2px 4px 0px rgba(0, 0, 0, 0.10)",
            borderRadius: "24px",
            // !Force popover to stay fixed in the designed position (70% layout)
            left: "722px !important",
            top: "820px !important",
          },
        },
        openIconWrapper: {
          backgroundColor: theme.palette.background.paper,
          height: "42px",
          width: "42px",
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: "9999px",
          color: theme.palette.text.secondary,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          "& .MuiSvgIcon-root": {
            width: "24px",
            height: "24px",
          },
        },
        closeIconWrapper: {
          display: "none",
          "& .MuiSvgIcon-root": {
            width: "24px",
            height: "24px",
          },
        },
        scrollUpButton: {
          position: "absolute",
          left: "50%",
          transform: "translateX(-50%)",
          top: "56px", // logoWrapper's height (42px) + spacing (14px)
          backgroundColor: theme.palette.background.default,
          border: `1px solid ${theme.palette.divider}`,
          height: "42px",
          width: "42px",
          zIndex: 1,
          "&:hover": {
            backgroundColor: theme.palette.background.default,
          },
        },
        scrollDownButton: {
          position: "absolute",
          left: "50%",
          transform: "translateX(-50%)",
          bottom: "14px",
          backgroundColor: theme.palette.background.default,
          border: `1px solid ${theme.palette.divider}`,
          height: "42px",
          width: "42px",
          zIndex: 1,
          "&:hover": {
            backgroundColor: theme.palette.background.default,
          },
        },
        floorAvatar: {
          background:
            "url(https://s3.venue.in.th/ordinal_button_pattern_9027ebd907.svg)",
          width: "62px",
          height: "62px",
          backgroundSize: "contain",
          borderRadius: "50%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "1.5rem",
          fontWeight: 700,
          color: theme.palette.primary.contrastText,
        },
        contentContainer: {
          position: "relative",
        },
        logoContainer: {
          display: "flex",
          flexDirection: "row",
          borderBottom: "1px solid transparent",
          borderImage:
            "linear-gradient(270deg, #EEE7CC 10.63%, #AC8700 51.45%, #EEE7CC 94.42%) 1",
          "&.ics": {
            order: 1,
          },
          "&.iconsiam": {
            order: 2,
          },
        },
        logoImage: {
          height: "18px",
        },
        logoWrapper: {
          height: "42px",
          background: theme.palette.background.paper,
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          flex: 1,
          padding: theme.spacing(1.5),
          "&.ics": {
            order: 1,
          },
          "&.iconsiam": {
            order: 2,
          },
        },
        levelContainer: {
          display: "flex",
          maxHeight: "548px",
          maskImage:
            "linear-gradient(to bottom, transparent, black 4%, black 90%, transparent)",
          height: "100%",
          overflow: "hidden auto",
          "&::-webkit-scrollbar": {
            display: "none",
          },
        },
        levelList: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1.5),
          flex: 1,
          padding: theme.spacing(7, 0),
          alignItems: "center",
          height: "100%",
          "&.ics": {
            order: 1,
            background: "#E4E2E070",
          },
          "&.iconsiam": {
            order: 2,
          },
        },
        levelButton: {
          backgroundColor: "transparent",
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: "50%",
          color: theme.palette.text.secondary,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "52px",
          width: "52px",
          fontSize: "1.25rem",
          padding: theme.spacing(1.5),
          position: "relative",
          backgroundSize: "contain",
          backgroundPosition: "center",
          flexShrink: 0,
          pointerEvents: "auto",
          "&.Mui-selected": {
            backgroundImage:
              "url(https://s3.venue.in.th/ordinal_button_pattern_9027ebd907.svg)",
            fontWeight: 700,
            color: theme.palette.primary.contrastText,
          },
          "&.is-unavailable": {
            pointerEvents: "none",
            visibility: "hidden",
          },
          "&.ics": {
            "&:not(.Mui-selected)": {
              backgroundImage:
                "url(https://s3.venue.in.th/ics_level_button_pattern_c3818c9801.svg)",
            },
            // Disable UG floor for ICS venue
            "&.ordinal-1": {
              pointerEvents: "none",
              visibility: "hidden",
            },
            "&.ordinal-2": {
              ":before": {
                content: "''",
                position: "absolute",
                left: "-4px",
                width: "160px",
                height: "60px",
                display: "inline-block",
                background:
                  "url(https://s3.venue.in.th/bts_floor_connector_90a03d0190.svg) center/contain no-repeat",
              },
            },
          },
        },
        currentLocationPopper: {
          pointerEvents: "none",
          "&[data-popper-placement*='right']": {},
          "& .MuiTooltip-tooltip": {
            backgroundColor: "transparent",
            padding: 0,
          },
        },
        currentLocation: {
          display: "inline-block",
          background:
            "url(https://s3.venue.in.th/ordinal_selector_you_are_here_7ab0f71938.png) center/contain no-repeat",
          width: 70,
          height: 55,
          zIndex: 1,
          animation: "horizontal-bounce 1.5s infinite",
        },
      },
    },
    AttractionButton: {
      defaultProps: {
        tabsOptions: {},
      },
      styleOverrides: {
        root: {
          width: 188,
          height: 188,
          position: "relative",
          cursor: "pointer",
        },
        carousel: {
          width: 188,
          height: 188,
          borderRadius: "50%",
          overflow: "hidden",
          border: "2px solid transparent",
          boxShadow:
            "33px 36px 14px 0px rgba(0, 0, 0, 0.00), 21px 23px 13px 0px rgba(0, 0, 0, 0.01), 12px 13px 11px 0px rgba(0, 0, 0, 0.04), 5px 6px 8px 0px rgba(0, 0, 0, 0.06), 1px 1px 4px 0px rgba(0, 0, 0, 0.07)",
          background:
            "linear-gradient(180deg, #FFFFFF 38.03%, #EDEEEE 100%, #FFF) padding-box, linear-gradient(333deg, #C8AF55 31.92%, #EEE7CC 81.85%) border-box",
          "& .splide": {
            height: "100%",
          },
          "& .splide__track": {
            height: "100%",
            padding: theme.spacing(1.25),
            margin: 0,
          },
          "&:after": {
            content: "''",
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            margin: theme.spacing(1.375),
            borderRadius: "50%",
            background:
              "linear-gradient(180deg, rgba(0, 0, 0, 0.1) 46.17%, rgba(0, 0, 0, 0.84) 85.67%)",
            pointerEvents: "none",
          },
        },
        carouselItem: {
          width: "100%",
          height: "100%",
          borderRadius: "50%",
        },
        image: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius: "50%",
        },
        attractionText: {
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          color: theme.palette.secondary.contrastText,
          fontWeight: 700,
          fontSize: "1.5rem",
          zIndex: 10,
          padding: theme.spacing(0.5, 1.5),
          borderRadius: "16px",
          textShadow: "1px 1px 4px rgba(0,0,0,0.8)",
          pointerEvents: "none",
        },
      },
    },
    AttractionModal: {
      defaultProps: {
        scrollableTabProps: {},
      },
      styleOverrides: {
        root: {
          height: "954px",
          width: "920px",
          backgroundColor: theme.palette.background.paper,
          borderRadius: "24px",
          position: "relative",
          overflow: "hidden",
        },
        contentContainer: {
          width: "100%",
          height: "760px",
          position: "relative",
          borderRadius: "24px 24px 0 0",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
        },
        image: {
          width: "100%",
          height: "100%",
          position: "absolute",
          objectFit: "cover",
          background: theme.palette.background.paper,
        },
        informationWrapper: {
          width: "100%",
          minHeight: "226px",
          display: "flex",
          justifyContent: "space-between",
          padding: theme.spacing(3),
          background:
            "linear-gradient(to top, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.6) 65%, rgba(0, 0, 0, 0) 100%)",
          zIndex: 2,
        },
        textContentWrapper: {
          padding: theme.spacing(3, 3, 0, 3),
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1.5),
          maxWidth: "500px",
          overflow: "hidden",
        },
        titleText: {
          color: theme.palette.primary.contrastText,
          fontWeight: 700,
          fontSize: "2rem",
        },
        descriptionText: {
          color: theme.palette.primary.contrastText,
          fontSize: "1.25rem",
          paddingLeft: theme.spacing(3),
          fontWeight: 400,
          borderLeft: "4px solid #AC8700",
          overflow: "hidden",
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 3,
        },
        buttonContainer: {
          display: "flex",
          alignItems: "flex-end",
        },
        locationButton: {
          width: "188px",
          height: "80px",
          background:
            "url(https://s3.venue.in.th/Button_188_px_78d4edf6c5.png) center/contain no-repeat",
          color: theme.palette.primary.contrastText,
          fontWeight: "500",
          fontSize: "20px",
          padding: theme.spacing(1, 1.5),
          borderRadius: "20px",
        },
        locationWrapper: {
          height: "194px",
          width: "100%",
          backgroundColor: "#F3F3F4",
          borderRadius: "0 0 24px 24px",
          position: "relative",
        },
        tabContainer: {
          width: "100%",
          height: "100%",
          "& .MuiTabs-root": {
            height: "100%",
          },
        },
        tabLabelContainer: {
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "space-between",
          height: "100%",
          width: "148px",
        },
        locationNameText: {
          maxWidth: "100px",
          fontSize: "1rem",
          alignItems: "center",
          textOverflow: "ellipsis",
          overflow: "hidden",
          display: "-webkit-box",
          WebkitLineClamp: 3,
          WebkitBoxOrient: "vertical",
        },
        levelText: {
          width: 40,
          height: 40,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: theme.palette.primary.contrastText,
          fontSize: "1.25rem",
          fontWeight: 500,
          background:
            "url(https://s3.venue.in.th/level_grey_6f54b2cf30.svg) , no-repeat",
        },
        tabItem: {
          width: "148px",
          height: "194px",
          color: theme.palette.common.black,
          padding: theme.spacing(4, 1.5),
          position: "relative",
          "&::after": {
            content: '""',
            position: "absolute",
            top: 0,
            right: 0,
            width: "1px",
            height: "100%",
            background:
              "linear-gradient(180deg, rgba(255, 255, 255, 0.00) -10.36%, rgba(234, 234, 236, 0.72) 6.26%,  #8C8A94 47.87%, rgba(235, 235, 237, 0.67) 93.96%, rgba(255, 255, 255, 0.00) 113.02%)",
            zIndex: 1,
          },
          "&.Mui-selected": {
            background: "linear-gradient(0deg, #AC8700 0%, #BA9B2A 88.96%)",
            color: theme.palette.primary.contrastText,
            fontWeight: 500,
            "& .level-text": {
              color: theme.palette.primary.main,
              background:
                "url(https://s3.venue.in.th/ics_level_button_pattern_c3818c9801.svg) no-repeat center / cover",
            },
            "& .attraction-name": {
              fontWeight: 500,
            },
          },
        },
      },
    },
    ProductModal: {
      styleOverrides: {
        root: {
          height: "1132px",
          width: "952px",
          backgroundColor: theme.palette.background.paper,
          borderRadius: "24px",
          position: "relative",
          overflow: "hidden",
        },
        productContainer: {
          display: "grid",
          gridTemplateColumns: "repeat(6, 1fr)",
          gridAutoRows: "max-content",
          gap: theme.spacing(1.5),
          width: "100%",
          height: "964px",
          padding: theme.spacing(5, 5, 3, 5),
          overflow: "hidden auto",
          background: theme.palette.background.default,
          "&::-webkit-scrollbar": {
            width: "4px",
          },
          "&::-webkit-scrollbar-track": {
            background: "transparent",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#8C8A94",
            borderRadius: "9999px",
          },
          "&:after": {
            content: "' '",
            position: "absolute",
            top: "918px",
            bottom: 0,
            left: 0,
            right: 0,
            background:
              "linear-gradient(180deg, rgba(248, 248, 255, 0) 0%, #F8F8FF 100%)",
            height: "48px",
            pointerEvents: "none",
          },
        },
        productCard: {
          gridColumn: "span 2",
          "&.highlight,:nth-child(1),:nth-child(2)": {
            width: "430px",
            gridColumn: "span 3",
            "& .ProductModal-fallbackCardMediaIcon": {
              width: "102px",
              height: "102px",
            },
          },
        },
        shopContainer: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          height: "168px",
          padding: theme.spacing(3),
        },
        shopInfoContainer: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: theme.spacing(1.5),
        },
        avatar: {
          width: "120px",
          height: "120px",
          borderRadius: 0,
          "& .MuiSvgIcon-root": {
            width: "60px",
            height: "60px",
          },
        },
        label: {
          fontSize: "1.75rem",
          fontWeight: 700,
          width: "268px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          lineHeight: 1.2,
          margin: 0,
        },
        qrCodeContainer: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: theme.spacing(1.5),
        },
        qrCode: {
          width: "120px",
          height: "120px",
        },
        qrCodeCaptionContainer: {
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
          gap: theme.spacing(0.5),
        },
        qrcodePrimaryText: {
          fontSize: "1.25rem",
          lineHeight: "1.2",
          fontWeight: 700,
          color: theme.palette.text.primary,
        },
        qrcodeSecondaryText: {
          textTransform: "lowercase",
          lineHeight: "1.2",
          fontSize: "1rem",
          color: theme.palette.text.primary,
        },
      },
    },
    ProductCard: {
      styleOverrides: {
        root: {
          position: "relative",
          width: "282px",
          aspectRatio: "1 / 1",
          borderRadius: "8px",
          gridColumn: "span 2",
          boxShadow: "none",
          "&.highlight,:nth-child(1),:nth-child(2)": {
            width: "430px",
            gridColumn: "span 3",
            "& .ProductModal-fallbackCardMediaIcon": {
              width: "102px",
              height: "102px",
            },
          },
        },
        cardMedia: {
          width: "100%",
          height: "100%",
          "&:after": {
            content: "''",
            display: "inline-block",
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 0,
            background:
              "linear-gradient(180deg, rgba(0, 0, 0, 0.10) 64.15%, rgba(0, 0, 0, 0.84) 99.87%)",
          },
        },
        cardContent: {
          position: "absolute",
          bottom: 0,
          left: 0,
        },
        cardTitle: {
          padding: theme.spacing(1.5),
          color: theme.palette.primary.contrastText,
          fontSize: "1.25rem",
          lineHeight: 1.5,
          fontWeight: 500,
          textOverflow: "ellipsis",
          overflow: "hidden",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          width: "226px",
          maxHeight: "77px",
        },
        fallbackCardMedia: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          width: "100%",
        },
        fallbackCardMediaIcon: {
          color: theme.palette.grey[400],
          width: "80px",
          height: "80px",
        },
      },
    },
    ReservationModal: {
      defaultProps: {
        carouselOptions: {
          arrowPath: "M31 19.4983L10 3L20.4966 19.4983L10 36L31 19.4983Z",
        },
      },
      styleOverrides: {
        root: {
          height: "620px",
          width: "952px",
          backgroundColor: theme.palette.background.paper,
          borderRadius: "24px",
          position: "relative",
          overflow: "hidden",
        },
        reservationContainer: {
          position: "relative",
          display: "grid",
          gridTemplateColumns: "repeat(6, 1fr)",
          gridAutoRows: "max-content",
          gap: theme.spacing(1.5),
          background: theme.palette.background.default,
          width: "100%",
          height: "452px",
          padding: theme.spacing(3),
          overflow: "hidden auto",
          "&::-webkit-scrollbar": {
            width: "4px",
          },
          "&::-webkit-scrollbar-track": {
            background: "transparent",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#8C8A94",
            borderRadius: "9999px",
          },
          "&:before": {
            content: "''",
            display: "inline-block",
            width: "80px",
            background: "linear-gradient(90deg, #F8F8FF, transparent)",
            maskImage:
              "linear-gradient(90deg, #000 0%, rgba(0, 0, 0, 0.00) 100%)",
            zIndex: 1,
            position: "absolute",
            top: 0,
            left: 0,
            bottom: 0,
            pointerEvents: "none",
          },
          "&:after": {
            content: "''",
            display: "inline-block",
            width: "80px",
            background: "linear-gradient(90deg,transparent,#F8F8FF);",
            maskImage:
              "linear-gradient(272deg, #000 0%, rgba(0, 0, 0, 0.00) 100%)",
            zIndex: 1,
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            pointerEvents: "none",
          },
          '[dir="rtl"] &': {
            "&:before": {
              background: "linear-gradient(90deg,transparent,#F8F8FF);",
              maskImage:
                "linear-gradient(272deg, #000 0%, rgba(0, 0, 0, 0.00) 100%)",
            },
            "&:after": {
              background: "linear-gradient(90deg, #F8F8FF, transparent)",
              maskImage:
                "linear-gradient(90deg, #000 0%, rgba(0, 0, 0, 0.00) 100%)",
            },
          },
        },
        shopContainer: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          height: "168px",
          gap: theme.spacing(3),
          padding: theme.spacing(3),
        },
        shopInfoContainer: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: theme.spacing(1.5),
          flex: 1,
          borderRight: "1px solid",
          borderImage:
            "linear-gradient(  to bottom,  rgba(0, 0, 0, 0) 0%, #C8AF55 30%, #C8AF55 70%,  rgba(0, 0, 0, 0) 100%) 1 100%",
        },
        avatar: {
          width: "120px",
          height: "120px",
          borderRadius: 0,
          "& .MuiSvgIcon-root": {
            width: "60px",
            height: "60px",
          },
        },
        label: {
          fontSize: "1.75rem",
          fontWeight: 700,
          width: "268px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          lineHeight: 1.2,
          margin: 0,
        },
        titleContainer: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: theme.spacing(1.5),
        },
        titleText: {
          margin: 0,
          fontWeight: 400,
          fontSize: "1.75rem",
          width: "268px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          lineHeight: 1.2,
        },
        carousel: {
          //TODO: update style arrow button
          "& .splide:not(.is-overflow)": {
            "& .splide__arrow": {
              opacity: 0,
            },
          },
          "& .splide__arrow": {
            color: theme.palette.text.secondary,
            width: "52px",
            height: "52px",
            opacity: 1,
            background: theme.palette.background.paper,
            border: `1px solid ${theme.palette.divider}`,
            transition: `opacity ${theme.transitions.duration.short}ms`,
            "& svg": {
              fill: "currentColor",
              width: "24px",
              height: "24px",
            },
          },
          "& .splide__arrow--prev": {
            left: "24px",
            "&:not([aria-label='Previous slide'])": {
              opacity: "0 !important",
            },
          },
          "& .splide__arrow--next": {
            right: "24px",
            "&:not([aria-label='Next slide'])": {
              opacity: "0 !important",
            },
          },
          "& .splide__track": {
            padding: theme.spacing(3, 3, 0),
          },
        },
        carouselItem: {},
        reservationCard: {},
      },
    },
    ReservationQRCodeCard: {
      styleOverrides: {
        root: {
          padding: theme.spacing(3, 1.5, 0, 1.5),
          display: "grid",
          width: "217px",
          height: "396px",
          boxShadow: "none",
          borderRadius: "24px",
          gridTemplateAreas: `
          "logo logo"
          "content content"
          "textContainer textContainer"
          `,
          gridTemplateRows: "112px 116px 1fr",
        },
        logoContainer: {
          gridArea: "logo",
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
        },
        logo: {
          width: "88px",
          height: "88px",
          borderRadius: "12px",
        },
        fallbackLogoIcon: {
          width: "42px",
          height: "42px",
        },
        divider: {
          display: "none",
          gridArea: "divider",
        },
        textContainer: {
          gridArea: "textContainer",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        },
        labelImage: { objectFit: "contain", width: "84px" },
        primaryText: {
          fontSize: "1.25rem",
          fontWeight: 700,
        },
        secondaryText: {
          fontSize: "1rem",
          fontWeight: 400,
        },
        content: {
          gridArea: "content",
        },
        qrCodeContainer: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          gap: theme.spacing(2.5),
        },
        qrCodeListItem: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: theme.spacing(1),
        },
        qrCode: {
          padding: theme.spacing(0, 0.5),
          border: "none",
          width: "80px",
          height: "80px",
        },
      },
    },
    ReservationContactCard: {
      styleOverrides: {
        root: {
          padding: theme.spacing(3, 1.5, 0, 1.5),
          display: "grid",
          width: "217px",
          height: "396px",
          boxShadow: "none",
          borderRadius: "24px",
          gridTemplateAreas: `
          "logo logo"
          "labelContainer labelContainer"
          "textContainer textContainer"
          `,
          gridTemplateRows: "112px 116px 1fr",
          "&:after": {
            content: "''",
            display: "inline-block",
            height: "30px",
            width: "100%",
            background: "linear-gradient(180deg,transparent,#ffffff);",
            maskImage:
              "linear-gradient(0deg, #000 0%, rgba(0, 0, 0, 0.00) 100%)",
            zIndex: 1,
            position: "absolute",
            right: 0,
            bottom: "30px",
            left: 0,
            pointerEvents: "none",
          },
        },
        logoContainer: {
          gridArea: "logo",
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
        },
        logo: {
          width: "88px",
          height: "88px",
          background: "transparent",
        },
        fallbackLogoIcon: {
          width: "88px",
          height: "88px",
          color: "#C6C5C9",
        },
        divider: {
          display: "none",
          gridArea: "divider",
        },
        labelContainer: {
          gridArea: "labelContainer",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "center",
        },
        textContainer: {
          position: "relative",
          gridArea: "textContainer",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "center",
          height: "110px",
          overflow: "hidden auto",
          paddingBottom: theme.spacing(1.875),
          "&::-webkit-scrollbar": {
            width: "4px",
          },
          "&::-webkit-scrollbar-track": {
            background: "transparent",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#8C8A94",
            borderRadius: "9999px",
          },
        },
        list: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1),
          maxHeight: "100%",
        },
        label: {
          fontSize: "1.25rem",
          fontWeight: 700,
          margin: 0,
        },
        contactTypeLabel: {
          fontSize: "1rem",
          fontWeight: 400,
          margin: 0,
        },
        primaryText: {
          fontSize: "1.25rem",
          fontWeight: 700,
          margin: 0,
        },
      },
    },
    ComingSoonChip: {
      styleOverrides: {
        root: {
          marginLeft: "auto",
          padding: theme.spacing(0.5, 1.5),
          height: "26px",
          borderRadius: "24px",
          backgroundColor: "#EFBB00",
          textTransform: "uppercase",
          "& .MuiChip-label": {
            padding: theme.spacing(0),
            fontSize: "0.875rem",
            fontWeight: 400,
            color: theme.palette.primary.contrastText,
          },
        },
      },
    },
    NewShopChip: {
      styleOverrides: {
        root: {
          marginLeft: "auto",
          padding: theme.spacing(0.5, 1.5),
          height: "26px",
          borderRadius: "24px",
          backgroundColor: "#F03D3D",
          "& .MuiChip-label": {
            padding: 0,
            fontSize: "0.875rem",
            fontWeight: 400,
            color: theme.palette.primary.contrastText,
          },
        },
      },
    },
    VatRefundChip: {
      styleOverrides: {
        root: {
          background:
            "linear-gradient(89.59deg, #0ED065 54.18%, rgba(14, 208, 101, 0) 100%)",
          padding: theme.spacing(0.25, 3, 0.25, 1),
          height: "21px",
          borderRadius: 0,
          justifyContent: "flex-start",
          "& .MuiChip-label": {
            padding: 0,
            fontSize: "0.8125rem",
            fontWeight: 400,
            color: theme.palette.common.white,
          },
        },
      },
    },
    FloorSelectionPanel: {
      styleOverrides: {
        root: {
          position: "fixed",
          right: "50px",
          bottom: "592px",
          width: "86px",
          transform: "translateY(-50%)",
          zIndex: 2,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: theme.spacing(1.25),
          background: theme.palette.background.paper,
          borderRadius: "64px",
          boxShadow:
            "33px 36px 14px 0px rgba(0, 0, 0, 0.00), 21px 23px 13px 0px rgba(0, 0, 0, 0.01), 12px 13px 11px 0px rgba(0, 0, 0, 0.04), 5px 6px 8px 0px rgba(0, 0, 0, 0.06), 1px 1px 4px 0px rgba(0, 0, 0, 0.07)",
        },
        buttonWrapper: {
          flexDirection: "column",
          padding: theme.spacing(1.5),
          "& .MuiToggleButtonGroup-grouped": {
            borderRadius: "50%",
            "&:not(:first-of-type)": {
              borderRadius: "50%",
              margin: 0,
              border: `1px solid ${theme.palette.divider}`,
            },
            "&:first-of-type": {
              borderRadius: "50%",
              margin: 0,
              border: `1px solid ${theme.palette.divider}`,
            },
          },
        },
        floorButton: {
          width: 62,
          height: 62,
          borderRadius: "50%",
          backgroundColor: theme.palette.background.paper,
          color: theme.palette.text.secondary,
          padding: 0,
          margin: 0,
          "&.Mui-selected": {
            background:
              "url(https://s3.venue.in.th/ordinal_button_pattern_9027ebd907.svg)",
            color: theme.palette.primary.contrastText,
            border: `2px solid ${theme.palette.primary.main}`,
          },
        },
        floorText: {
          fontSize: "1.5rem",
          fontWeight: 700,
          lineHeight: 1,
        },
      },
    },
    TouristRegistrationPanel: {
      styleOverrides: {
        root: {
          position: "fixed",
          left: 0,
          bottom: 360,
          zIndex: 1300,
          width: "64px",
          height: "231px",
        },
        triggerPanel: {
          position: "relative",
          borderRadius: "0 16px 16px 0",
          backgroundColor: "#FFFE41",
          width: "64px",
          height: "231px",
          padding: "20px",
          backgroundSize: "auto",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundImage:
            "url('https://s3.venue.in.th/onesiam_visitor_vertical_logo_0eac82b10c.svg')",
          cursor: "pointer",
          boxShadow:
            "0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.06)",
        },
        animationWrapper: {
          position: "absolute",
          top: 0,
          transform: "translateX(40px)",
          '[dir="rtl"] &': {
            left: 0,
          },
        },
        contentContainer: {
          width: "269px",
          height: "231px",
          borderRadius: "0px 16px 16px 0px",
          backgroundColor: theme.palette.background.paper,
          boxShadow:
            "0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.06)",
          overflow: "visible",
        },
        header: {
          width: "100%",
          height: "67px",
          backgroundColor: "#FFFE41",
          backgroundImage:
            "url('https://s3.venue.in.th/onesiam_visitor_horizontal_logo_3190eea5c5.svg')",
          backgroundSize: "auto",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          borderRadius: "0px 16px 0px 0px",
        },
        informationWrapper: {
          display: "flex",
          width: "100%",
          height: "164px",
          padding: theme.spacing(2.5),
          justifyContent: "space-between",
        },
        textContainer: { maxWidth: "126px", borderBottom: "1px solid #C6C5C9" },
        primaryText: {
          fontSize: "1.125rem",
          fontWeight: 700,
          color: "#0E0E0E",
        },
        secondaryText: {
          fontSize: "1.125rem",
          fontWeight: 400,
          color: "#0E0E0E",
        },
        tertiaryText: {
          fontSize: "0.875rem",
          fontWeight: 400,
          color: "#0E0E0E",
        },
        qrCodeContainer: {
          width: "78px",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
        },
        qrCode: {
          "&.AppQRCode-root": {
            border: "none",
            padding: 0,
            margin: 0,
            height: "100%",
            minHeight: "78px",
            boxShadow: "none",
            borderRadius: 0,
            justifyContent: "space-between",
          },
          "& .AppQRCode-content": {
            padding: 0,
            margin: 0,
            maxWidth: "78px",
            maxHeight: "78px",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
          },
          "& .AppQRCode-caption": {
            paddingTop: theme.spacing(2),
            fontSize: "0.875rem",
            textTransform: "none",
            fontWeight: 700,
          },
          "& .AppQRCode-secondary-caption": {
            display: "none",
          },
        },
        iconButton: {
          position: "absolute",
          top: "50%",
          transform: "translateY(-50%)",
          right: "-24px",
          backgroundColor: theme.palette.background.default,
          width: "24px",
          height: "32px",
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: "0 8px 8px 0",
          color: theme.palette.text.secondary,
          padding: 0,
          "& .MuiSvgIcon-root": {
            width: "16px",
            height: "16px",
          },
        },
      },
    },
    SideBannerPanel: {
      styleOverrides: {
        root: {
          position: "fixed",
          left: 0,
          bottom: 607,
          zIndex: 1300,
          width: "64px",
          height: "231px",
        },
        triggerPanel: {
          position: "relative",
          borderRadius: "0 16px 16px 0",
          backgroundColor: "#FFFE41",
          width: "64px",
          height: "231px",
          padding: "20px",
          backgroundSize: "auto",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundImage:
            "url('https://s3.venue.in.th/side_trigger_banner_f600b0a835.png')",
          cursor: "pointer",
          boxShadow:
            "0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.06)",
        },
        animationWrapper: {
          position: "absolute",
          top: 0,
          transform: "translateX(40px)",
          '[dir="rtl"] &': {
            left: 0,
          },
        },
        contentContainer: {
          width: "269px",
          height: "231px",
          borderRadius: "0px 16px 16px 0px",
          backgroundColor: theme.palette.background.paper,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundImage:
            "url('https://s3.venue.in.th/side_banner_content_3c64c8a4b6.png')",
          boxShadow:
            "0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.06)",
          overflow: "visible",
        },
        iconButton: {
          position: "absolute",
          top: "50%",
          transform: "translateY(-50%)",
          right: "-24px",
          backgroundColor: theme.palette.background.default,
          width: "24px",
          height: "32px",
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: "0 8px 8px 0",
          color: theme.palette.text.secondary,
          padding: 0,
          "& .MuiSvgIcon-root": {
            width: "16px",
            height: "16px",
          },
        },
      },
    },
  },
})
